var Ar = (t) => {
  throw TypeError(t);
};
var Qt = (t, e, r) => e.has(t) || Ar("Cannot " + r);
var o = (t, e, r) => (Qt(t, e, "read from private field"), r ? r.call(t) : e.get(t)), S = (t, e, r) => e.has(t) ? Ar("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, r), b = (t, e, r, s) => (Qt(t, e, "write to private field"), s ? s.call(t, r) : e.set(t, r), r), T = (t, e, r) => (Qt(t, e, "access private method"), r);
var Pt = (t, e, r, s) => ({
  set _(n) {
    b(t, e, n, r);
  },
  get _() {
    return o(t, e, s);
  }
});
import { create as Xs } from "zustand";
import { devtools as Zs, subscribeWithSelector as en } from "zustand/middleware";
import { immer as tn } from "zustand/middleware/immer";
import { signInWithEmailAndPassword as rn, signOut as sn, sendPasswordResetEmail as nn, verifyPasswordResetCode as an, confirmPasswordReset as on, onAuthStateChanged as ln } from "firebase/auth";
import { jsx as m, jsxs as M, Fragment as $t } from "react/jsx-runtime";
import * as q from "react";
import { useEffect as Ye, forwardRef as cs, createElement as Jt, createContext as un, useContext as cn, useState as W, useRef as dn, useCallback as hn } from "react";
import { doc as dt, getDoc as ht } from "firebase/firestore";
import { userReadableSchema as fn, userEditableSchema as mn, companySchema as ds, signupResponseSchema as pn } from "@qura/shared-types";
import { AuthBackground as Ze, AuthContainerCard as et, AuthInputCard as tt, AuthLogo as rt, AuthDescription as st, AuthTextInput as Xe, AuthPasswordInput as Yt, AuthError as Lt, AuthSubmitButton as Ae, AuthFooter as nt, LoadingPage as gn } from "@qura/ui";
import { z as yn } from "zod";
const wn = {
  data: null,
  user: null,
  isInitialized: !1,
  authDisabled: !1,
  auth: null
}, z = Xs()(
  Zs(
    tn(
      en(
        () => wn
      )
    ),
    { name: "auth" }
  )
), bn = () => z((t) => t.user), po = () => z((t) => t.data), kn = () => z((t) => t.isInitialized), br = async (t, e) => {
  const { auth: r, authDisabled: s, user: n } = z.getState();
  if (s) {
    if (n)
      return n;
    throw new Error("Auth is disabled");
  }
  if (!r) throw new Error("Auth is not initialized");
  const { user: i } = await rn(r, t, e);
  return i;
}, It = async () => {
  const { auth: t, authDisabled: e } = z.getState();
  if (!e) {
    if (!t) throw new Error("Auth is not initialized");
    await sn(t), z.setState({ data: null, user: void 0, isInitialized: !0 }, !1, "user/logout");
  }
}, kr = async () => {
  var r;
  const { auth: t, authDisabled: e } = z.getState();
  if (e) return null;
  if (!t) throw new Error("Auth is not initialized");
  return ((r = t.currentUser) == null ? void 0 : r.getIdToken(!0)) ?? null;
}, go = () => br, yo = () => It, wo = () => kr;
async function Sn(t, e) {
  const r = dt(t, "users_readable", e), s = dt(t, "users_editable", e), [n, i] = await Promise.all([
    ht(r),
    ht(s)
  ]);
  if (!n.exists())
    throw new Error("User readable data not found");
  if (!i.exists())
    throw new Error("User editable data not found");
  const a = fn.parse(n.data()), l = mn.parse(i.data()), f = dt(t, "companies_readable", a.company_id), u = await ht(f);
  if (!u.exists())
    throw new Error("Company not found");
  const c = ds.parse({
    ...u.data(),
    companyId: u.id
  });
  return {
    user_readable: a,
    user_editable: l,
    company: c
  };
}
async function vn(t, e) {
  try {
    const r = dt(t, "signup_tokens", e), s = await ht(r);
    if (!s.exists())
      throw new Error("Signup token not found");
    const n = s.data().company_id, i = dt(t, "companies_readable", n), a = await ht(i);
    if (!a.exists())
      throw new Error("Company not found");
    return ds.parse({ ...a.data(), companyId: n });
  } catch (r) {
    throw console.error(r), r;
  }
}
async function Pn({ email: t }) {
  try {
    const e = z.getState().auth;
    if (!e) throw new Error("Auth not initialized");
    await nn(e, t);
  } catch (e) {
    throw console.error(e), e;
  }
}
async function En({ code: t, password: e }) {
  const r = z.getState().auth;
  if (!r) throw new Error("Auth not initialized");
  await an(r, t), await on(r, t, e);
}
const Rn = {
  user_editable: {
    language: "en",
    display_name: "Demo",
    has_seen_quick_guide: !1,
    should_reload: !1
  },
  user_readable: {
    company_id: "demo",
    created_at: /* @__PURE__ */ new Date(),
    email_verified: !0,
    signup_token_id: null,
    search_history_active: !0,
    email: "demo@demo.com"
  },
  company: {
    company_id: "demo",
    name: "Demo"
  }
}, Cn = {
  data: Rn,
  isInitialized: !0,
  user: {
    uid: "demo",
    email: "demo@demo.com",
    displayName: "Demo",
    emailVerified: !0,
    isAnonymous: !1,
    metadata: {
      creationTime: (/* @__PURE__ */ new Date()).toISOString()
    },
    providerData: [],
    refreshToken: "demo",
    tenantId: null,
    delete: () => Promise.resolve(),
    getIdToken: () => Promise.resolve("demo"),
    getIdTokenResult: () => Promise.resolve({ token: "demo", claims: {} }),
    reload: () => Promise.resolve(),
    toJSON: () => ({}),
    phoneNumber: null,
    photoURL: null,
    providerId: "password"
  },
  authDisabled: !0,
  auth: null
}, Tn = (t) => {
  const e = (t == null ? void 0 : t.minLoadingTime) ?? 0, r = t.auth, s = t.db;
  return ln(r, async (i) => {
    if (!i) {
      z.setState(
        { data: null, user: void 0, isInitialized: !0 },
        !1,
        "user/no-user"
      );
      return;
    }
    const a = new Promise((l) => setTimeout(l, e));
    Promise.all([Sn(s, i.uid), z.setState({ user: i }), a]).then(([l]) => {
      z.setState(
        { data: l, user: i, isInitialized: !0 },
        !1,
        "user/initialized"
      );
    }).catch((l) => {
      console.error("Error getting user data:", l), z.setState(
        { data: null, user: void 0, isInitialized: !0 },
        !1,
        "user/error"
      ), It();
    });
  });
};
function On({
  db: t,
  auth: e,
  minLoadingTime: r,
  disableAuth: s
}) {
  return Ye(() => {
    s ? z.setState({ ...Cn }) : z.setState({ auth: e });
    const n = Tn({
      auth: e,
      db: t,
      minLoadingTime: r ?? 0
    });
    return () => n();
  }, []), null;
}
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dn = (t) => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), hs = (...t) => t.filter((e, r, s) => !!e && e.trim() !== "" && s.indexOf(e) === r).join(" ").trim();
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var An = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fn = cs(
  ({
    color: t = "currentColor",
    size: e = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: s,
    className: n = "",
    children: i,
    iconNode: a,
    ...l
  }, f) => Jt(
    "svg",
    {
      ref: f,
      ...An,
      width: e,
      height: e,
      stroke: t,
      strokeWidth: s ? Number(r) * 24 / Number(e) : r,
      className: hs("lucide", n),
      ...l
    },
    [
      ...a.map(([u, c]) => Jt(u, c)),
      ...Array.isArray(i) ? i : [i]
    ]
  )
);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mt = (t, e) => {
  const r = cs(
    ({ className: s, ...n }, i) => Jt(Fn, {
      ref: i,
      iconNode: e,
      className: hs(`lucide-${Dn(t)}`, s),
      ...n
    })
  );
  return r.displayName = `${t}`, r;
};
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fs = Mt("ArrowLeft", [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ft = Mt("Lock", [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sr = Mt("Mail", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }]
]);
/**
 * @license lucide-react v0.462.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xn = Mt("User", [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
]), Nn = {
  loginPage: {
    title: "Log In",
    forgotPassword: "Forgot password?",
    login: "Log in",
    description: `Enter your details
to sign in to your account`
  },
  confirmEmailPage: {
    title: "Confirm Email",
    confirmedMessage: "Your email has been confirmed. You can now log in.",
    confirmEmailMessage: "Confirm your email adress to log in. We've sent a confirmation link to:",
    isLoading: "Sending...",
    resendLink: "Resend Link",
    backToLogin: "Back to Login",
    spamEmail: "Don't forget to check your spam folder",
    confirming: "Confirming your email",
    confirmingError: "Failed to confirm your email. Please try again."
  },
  forgotPasswordPage: {
    title: "Forgot Password",
    recoverPassword: "Recover Password",
    emailSentSuccess: "A link to reset your password has been sent to your email.",
    description: `Enter your email
to recover your password`
  },
  resetPasswordPage: {
    resetPassword: "Reset Password",
    passwordPlaceholder: "Enter new password",
    confirmPasswordPlaceholder: "Confirm new password",
    login: "Log in",
    success: {
      passwordReset: "Your password has been reset!",
      backToLogin: "Back to Login"
    }
  },
  signupPage: {
    namePlaceholder: "Enter your name",
    confirmPasswordPlaceholder: "Confirm your password",
    signup: "Sign Up",
    description: `Enter your details
to create a new account`
  },
  feedback: {
    input: "Type your feedback here...",
    success: "Feedback sent",
    failed: "Failed to send feedback"
  },
  searchPromptPage: {
    subtitle: "Ask in natural language what you are searching for"
  },
  userDropdown: {
    changePassword: "Change Password",
    logout: "Log Out",
    pending: "Sending reset password email...",
    success: "A link to reset your password has been sent to your email.",
    error: "Failed to send reset password email. Please try again."
  },
  searchBar: {
    placeholder: "Search Qura AI...",
    searchingStatus: "Searching in document",
    documentMatch: "Document Match",
    suggestions: "Suggestions",
    searchHistory: "Search History",
    seeAll: "See all",
    inDocumentSearch: "Search in document"
  },
  searchHistory: {
    searchHistory: "Search History",
    documentsVisited: {
      one: "{{count}} visited document",
      other: "{{count}} visited documents"
    }
  },
  searchResult: {
    openTag: "Open",
    noSearchResults: "No search results found",
    tryUpdateFilters: "Try updating your filters or query.",
    newSearch: "New Search",
    searchMatch: "Search match",
    pageNumberShort: "p.",
    openPdf: "Open",
    clickToExpand: "Click to expand",
    clickToMinimize: "Click to minimize",
    previewLoading: "Loading preview...",
    previewError: "Failed to load preview",
    noPreview: "No preview available",
    feedbackSubmitted: "Thank you for your feedback!",
    keywords: "Keywords"
  },
  searchDocumentPage: {
    title: "Search results in document",
    downloadDocumentWithHighlights: "Download PDF with highlights",
    downloadDocumentWithoutHighlights: "Download PDF without highlights",
    downloadHighlightedPages: "Download highlighted pages",
    printDocumentWithHighlights: "Print PDF with highlights",
    printDocumentWithoutHighlights: "Print PDF without highlights",
    printHighlightedPages: "Print highlighted pages",
    downloadError: "Failed to download PDF",
    backToSearch: "Back to search",
    foundChunksCount: {
      one: "Found {{count}} relevant page",
      other: "Found {{count}} relevant pages"
    },
    loadingChunks: "Loading pages...",
    noChunksFound: "No relevant pages found",
    referenceNotFound: "Document currently not available",
    citedDocuments: "Cited Documents",
    citedByDocuments: "Cited By Documents",
    relatedDocuments: "Related Documents",
    deepSearch: "Refine Search"
  },
  documentMetadata: {
    legal_id: "Legal ID",
    publication_date: "Publication Date",
    source: "Source",
    no_source_link: "Source not available"
  },
  filters: {
    filter: "Filter",
    filterByYear: "Filter by year",
    applyFilters: "Apply selected filters",
    from: "From",
    to: "to",
    reset: "Reset",
    legalSources: "Legal Sources",
    date: "Date"
  },
  errors: {
    invalidCredentials: "Invalid Credentials",
    network: "You are offline.",
    invalidSignupToken: "Your signup link is invalid.",
    emailNotConfirmed: "Email not confirmed.",
    emailAlreadyUsed: "Email has already been used with another account.",
    noResults: "No results found.",
    loadResourcesFailed: `Our servers are currently down.
Please try again later.`,
    resultChunkFailed: "Failed to load preview in ResultChunk with react pdf document. Error: ",
    unknown: "An unknown has error occurred.",
    invalidSearchId: "Was not able to find the search on this link.",
    invalidEmail: "Your email is invalid.",
    invalidPassword: "Your password is invalid.",
    invalidUsername: "Your name is invalid.",
    document404Title: "Could not find the document",
    document404Description: "Please write in the feedback form if this should be a link to a document.",
    search404Title: "Could not find the search",
    search404Description: "Please write in the feedback form if this should not have happened.",
    dataRole404Title: "User is not valid",
    dataRole404Description: "Please contact us to resolve this.",
    errorPageTitle: "Unknown Error",
    errorPageDescription: "This should not have happened. Please write in the feedback form to help us understand what went wrong.",
    searchFailed: "Failed to start search. Please try again.",
    nameRequired: "Name is required.",
    nameTooShort: "Name must be at least three characters long.",
    emailRequired: "Email is required.",
    emailInvalid: "Invalid email format.",
    passwordRequired: "Password is required.",
    passwordTooShort: "Password must be at least 8 characters long.",
    passwordMismatch: "Passwords do not match."
  },
  common: {
    tryAgain: "Try again",
    passwordPlaceholder: "Enter your password",
    emailPlaceholder: "Enter your email",
    login: "Login",
    loading: "Loading...",
    password: "Password",
    email: "Email",
    confirmPassword: "Confirm password",
    name: "Name",
    month: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    weekday: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    today: "Today",
    yesterday: "Yesterday",
    tomorrow: "Tomorrow",
    lastWeekday: [
      "Last Sunday",
      "Last Monday",
      "Last Tuesday",
      "Last Wednesday",
      "Last Thursday",
      "Last Friday",
      "Last Saturday"
    ],
    backToHome: "Back to home",
    loadMore: "Load more"
  },
  searchStatus: {
    searchScore: "Search Score",
    documentsFound: "Found Documents",
    documentsSearched: "Searched Documents",
    analyzingQuery: "Analyzing Query",
    searchingDatabases: "Searching Database",
    rankingDocuments: "Ranking Documents",
    done: "Done",
    completed: "Completed",
    ongoing: "In Progress...",
    pending: "Pending",
    error: "Failed"
  },
  layout: {
    allResults: "All Results"
  },
  databaseInformation: {
    databaseInformation: "Database Information"
  },
  examplePrompts: {
    swe: [
      "Hur ska köp av osäkra fordringar behandlas i mervärdesskattehänseende?",
      "Vad har brottslighetens art tillmätts för betydelse vid påföljdsval i rättspraxis?",
      "När kan en statlig myndighet ha klagorätt genom att företräda ett privaträttsligt intresse?"
    ],
    eu: [
      'How is "communication to the public" interpreted in article 3(19) of Directive 2001/29?',
      "How does judicial independence relate to the right to a fair trial?",
      'How to decide where a child is a "habitually resident"?'
    ],
    default: [
      'How is "communication to the public" interpreted in article 3(19) of Directive 2001/29?',
      "How does judicial independence relate to the right to a fair trial?",
      'How to decide where a child is a "habitually resident"?'
    ]
  },
  authFooter: "Qura uses AI to find the relevant laws, cases and regulations for any legal context. We strive to transform legal research.",
  authFooterAlt1: "© 2024 Lawlabs AB ",
  authFooterAlt2: "Stockholm 111 20",
  onboardingPage: {
    title: "Get Started with Our Quick Guide",
    welcomeMessage: "Welcome to Qura!",
    learnHowToUseQura: "Learn how to use Qura.",
    description: "We provide tips on how to make the best use of our powerful AI search engine and its features.",
    viewQuickGuide: "View Quick Guide",
    showMeLater: "Show me later",
    haveMoreQuestions: "Do you have more questions?",
    contactTeam: "Contact the team"
  },
  helpButton: {
    modalLabel: "Do you need help?",
    modalTitle: "Quick Guide",
    modalDescription: "Learn how to use Qura's powerful AI search engine.",
    viewQuickGuide: "View Quick Guide",
    haveMoreQuestions: "Do you have more questions?",
    contactTeam: "Contact the team",
    notificationTitle: "Quick Guide",
    notificationDescription: "You can always find it in the question mark."
  },
  relatedDocuments: {
    title: "Related Documents",
    citedDocuments: "Cited Documents",
    citedByDocuments: "Cited By Documents"
  },
  NPSForm: {
    modalLabel: "Help us get better",
    modalQuestion: "How likely are you to recommend Qura to a friend or colleague?",
    dismissButton: "Remind me later",
    lowerBound: "1 = Not likely",
    upperBound: "10 = Very likely"
  }
}, Ln = {
  loginPage: {
    title: "Logga in",
    forgotPassword: "Glömt lösenord?",
    login: "Logga in",
    description: `Ange dina uppgifter
för att logga in`
  },
  confirmEmailPage: {
    title: "Bekräfta e-post",
    confirmedMessage: "Din e-post har bekräftats. Du kan nu logga in.",
    confirmEmailMessage: "Bekräfta din e-postadress för att logga in. Vi har skickat en bekräftelselänk till:",
    isLoading: "Skickar...",
    resendLink: "Skicka länken igen",
    backToLogin: "Tillbaka till inloggning",
    spamEmail: "Glöm inte att kolla din skräppost",
    confirming: "Bekräftar din e-post",
    confirmingError: "Misslyckades med att bekräfta din e-post. Försök igen."
  },
  forgotPasswordPage: {
    title: "Glömt lösenord",
    recoverPassword: "Återställ lösenord",
    emailSentSuccess: "En länk för att återställa ditt lösenord har skickats till din e-post.",
    description: `Ange din e-post
för att återställa ditt lösenord`
  },
  resetPasswordPage: {
    resetPassword: "Återställ lösenord",
    passwordPlaceholder: "Ange nytt lösenord",
    confirmPasswordPlaceholder: "Bekräfta nytt lösenord",
    success: {
      passwordReset: "Ditt lösenord har återställts!",
      backToLogin: "Tillbaka till inloggning"
    },
    login: "Logga in"
  },
  signupPage: {
    namePlaceholder: "Ange ditt namn",
    confirmPasswordPlaceholder: "Bekräfta ditt lösenord",
    signup: "Registrera dig",
    description: `Enter your details
to create a new account`
  },
  feedback: {
    input: "Skriv din feedback här...",
    success: "Feedback skickad",
    failed: "Misslyckades med att skicka feedback"
  },
  searchPromptPage: {
    subtitle: "Skriv i fritext vad du söker efter"
  },
  userDropdown: {
    changePassword: "Byt lösenord",
    logout: "Logga ut",
    pending: "Skickar e-post för återställning av lösenord...",
    success: "En länk för att återställa ditt lösenord har skickats till din e-post.",
    error: "Misslyckades med att skicka e-post för återställning av lösenord. Försök igen."
  },
  searchBar: {
    placeholder: "Sök Qura AI...",
    searchingStatus: "Söker i dokument",
    documentMatch: "Dokumentmatch",
    suggestions: "Förslag",
    searchHistory: "Sökhistorik",
    seeAll: "Visa allt",
    inDocumentSearch: "Sök i dokument"
  },
  searchHistory: {
    searchHistory: "Sökhistorik",
    documentsVisited: {
      one: "{{count}} besökt dokument",
      other: "{{count}} besökta dokument"
    }
  },
  searchResult: {
    openTag: "Öppna",
    noSearchResults: "Inga sökresultat hittades",
    tryUpdateFilters: "Försök att uppdatera dina filter eller sökfråga.",
    newSearch: "Ny sökning",
    searchMatch: "Matchar",
    pageNumberShort: "s.",
    openPdf: "Öppna",
    clickToExpand: "Klicka för att expandera",
    clickToMinimize: "Klicka för att minimera",
    previewLoading: "Laddar förhandsvisning...",
    previewError: "Misslyckades med att ladda förhandsvisning",
    noPreview: "Ingen förhandsvisning tillgänglig",
    feedbackSubmitted: "Tack för din feedback!",
    keywords: "Nyckelord"
  },
  searchDocumentPage: {
    title: "Sökresultat i dokument",
    downloadDocumentWithHighlights: "Ladda ner PDF med markeringar",
    downloadDocumentWithoutHighlights: "Ladda ner PDF utan markeringar",
    downloadHighlightedPages: "Ladda ner endast markeringar",
    printDocumentWithHighlights: "Skriv ut PDF med markeringar",
    printDocumentWithoutHighlights: "Skriv ut PDF utan markeringar",
    printHighlightedPages: "Skriv ut endast markeringar",
    downloadError: "Misslyckades med att ladda ner PDF",
    backToSearch: "Tillbaka till sökning",
    foundChunksCount: {
      one: "Hittade {{count}} relevant sida",
      other: "Hittade {{count}} relevanta sidor"
    },
    loadingChunks: "Laddar sidor...",
    noChunksFound: "Inga relevanta sidor hittades",
    referenceNotFound: "Dokumentet är för närvarande inte tillgängligt",
    citedDocuments: "Refererade dokument",
    citedByDocuments: "Refereras av dokument",
    relatedDocuments: "Relaterade dokument",
    deepSearch: "Förfina sökning"
  },
  documentMetadata: {
    legal_id: "Juridiskt ID",
    publication_date: "Publiceringsdatum",
    source: "Källa",
    no_source_link: "Källa ej tillgänglig"
  },
  filters: {
    filter: "Filter",
    filterByYear: "Filtrera efter år",
    applyFilters: "Tillämpa valda filter",
    from: "Från",
    to: "till",
    reset: "Återställ",
    legalSources: "Rättskällor",
    date: "Datum"
  },
  errors: {
    invalidCredentials: "Ogiltiga uppgifter",
    network: "Du är offline.",
    invalidSignupToken: "Din registreringslänk är ogiltig.",
    emailNotConfirmed: "E-post ej bekräftad.",
    emailAlreadyUsed: "E-post har redan använts med ett annat konto.",
    noResults: "Inga resultat hittades.",
    loadResourcesFailed: `Våra servrar är för närvarande nere.
Försök igen senare.`,
    resultChunkFailed: "Misslyckades med att läsa in förhandsgranskning i ResultChunk med react pdf dokument. Fel: ",
    unknown: "Ett okänt fel har inträffat.",
    invalidSearchId: "Kunde inte hitta sökningen på denna länk.",
    invalidEmail: "Din e-post är ogiltig.",
    invalidPassword: "Ditt lösenord är ogiltigt.",
    invalidUsername: "Ditt namn är ogiltigt.",
    document404Title: "Kunde inte hitta dokumentet",
    document404Description: "Skriv gärna i feedback rutan om detta borde vara en länk till ett dokument.",
    search404Title: "Kunde inte hitta sökningen",
    search404Description: "Skriv gärna i feedback rutan om detta inte borde ha hänt.",
    dataRole404Title: "Användaren är ogiltig",
    dataRole404Description: "Kontakta oss för att lösa detta.",
    errorPageTitle: "Okänt Fel",
    errorPageDescription: "Detta borde inte ha hänt. Skriv gärna i feedback rutan för att hjälpa oss förstå vad som gick fel.",
    searchFailed: "Misslyckades med att starta sökningen. Försök igen.",
    nameRequired: "Namn är obligatoriskt.",
    nameTooShort: "Namn måste vara minst tre tecken långt.",
    emailRequired: "E-post är obligatorisk.",
    emailInvalid: "Ogiltig e-postadress.",
    passwordRequired: "Lösenord är obligatoriskt.",
    passwordTooShort: "Lösenord måste vara minst 8 tecken långt.",
    passwordMismatch: "Lösenorden matchar inte."
  },
  common: {
    tryAgain: "Försök igen",
    passwordPlaceholder: "Ange ditt lösenord",
    emailPlaceholder: "Ange din e-post",
    login: "Logga in",
    loading: "Laddar...",
    password: "Lösenord",
    email: "E-post",
    confirmPassword: "Bekräfta lösenord",
    name: "Namn",
    month: [
      "januari",
      "februari",
      "mars",
      "april",
      "maj",
      "juni",
      "juli",
      "augusti",
      "september",
      "oktober",
      "november",
      "december"
    ],
    weekday: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"],
    today: "Idag",
    yesterday: "Igår",
    tomorrow: "Imorgon",
    lastWeekday: [
      "I söndags",
      "I måndags",
      "I tisdags",
      "I onsdags",
      "I torsdags",
      "I fredags",
      "I lördags"
    ],
    backToHome: "Tillbaka till startsidan",
    loadMore: "Ladda fler"
  },
  layout: {
    allResults: "Alla resultat"
  },
  searchStatus: {
    searchScore: "Träffsäkerhet",
    documentsFound: "Hittade dokument",
    documentsSearched: "Sökta dokument",
    analyzingQuery: "Analyserar frågan",
    searchingDatabases: "Söker i databasen",
    rankingDocuments: "Rankar dokumenten",
    done: "Klar",
    completed: "Färdig",
    ongoing: "Pågående...",
    pending: "Väntar",
    error: "Misslyckades"
  },
  databaseInformation: {
    databaseInformation: "Databasinformation"
  },
  authFooter: "Qura använder AI för att hitta relevanta lagar, fall och förordningar för varje juridiskt sammanhang. Vi strävar efter att transformera juridisk forskning.",
  authFooterAlt1: "© 2024 Lawlabs AB ",
  authFooterAlt2: "Stockholm 111 20",
  examplePrompts: {
    swe: [
      "Hur ska köp av osäkra fordringar behandlas i mervärdesskattehänseende?",
      "Vad har brottslighetens art tillmätts för betydelse vid påföljdsval i rättspraxis?",
      "När kan en statlig myndighet ha klagorätt genom att företräda ett privaträttsligt intresse?"
    ],
    eu: [
      'How is "communication to the public" interpreted in article 3(19) of Directive 2001/29?',
      "How does judicial independence relate to the right to a fair trial?",
      'How to decide where a child is a "habitually resident"?'
    ],
    default: [
      "Hur ska köp av osäkra fordringar behandlas i mervärdesskattehänseende?",
      "Vad har brottslighetens art tillmätts för betydelse vid påföljdsval i rättspraxis?",
      "När kan en statlig myndighet ha klagorätt genom att företräda ett privaträttsligt intresse?"
    ]
  },
  onboardingPage: {
    title: "Kom igång med vår Quick Guide",
    welcomeMessage: "Välkommen till Qura!",
    learnHowToUseQura: "Lär dig hur du använder Qura.",
    description: "Vi ger dig tips på hur du utnyttjar vår kraftfulla AI-sökmotor och dess funktioner på bästa sätt.",
    viewQuickGuide: "Se Quick Guide",
    showMeLater: "Visa mig senare",
    haveMoreQuestions: "Har du fler frågor?",
    contactTeam: "Kontakta teamet"
  },
  helpButton: {
    modalLabel: "Behöver du hjälp?",
    modalTitle: "Quick Guide",
    modalDescription: "Lär dig hur du utnyttjar Quras kraftfulla AI-sökmotor.",
    viewQuickGuide: "Se Quick Guide",
    haveMoreQuestions: "Har du fler frågor?",
    contactTeam: "Kontakta teamet",
    notificationTitle: "Quick Guide",
    notificationDescription: "Du hittar den alltid i frågetecknet."
  },
  relatedDocuments: {
    title: "Relaterade dokument",
    citedDocuments: "Citerade dokument",
    citedByDocuments: "Citerat av dokument"
  },
  NPSForm: {
    modalLabel: "Hjälp oss att bli bättre",
    modalQuestion: "Hur troligt är det att du skulle rekommendera Qura till en vän eller kollega?",
    dismissButton: "Påminn mig senare",
    lowerBound: "1 = Inte troligt",
    upperBound: "10 = Mycket troligt"
  }
}, In = {
  en: Nn,
  sv: Ln
}, ms = un({ locale: "sv" }), Fe = () => {
  const t = cn(ms);
  if (!t)
    throw new Error("useTranslations must be used within a TranslationsProvider");
  return In[t.locale];
}, Mn = ({ children: t, locale: e }) => /* @__PURE__ */ m(ms.Provider, { value: { locale: e }, children: t });
var it = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(t) {
    return this.listeners.add(t), this.onSubscribe(), () => {
      this.listeners.delete(t), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, xe = typeof window > "u" || "Deno" in globalThis;
function Y() {
}
function Un(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Xt(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function ps(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function Ue(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function ee(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Fr(t, e) {
  const {
    type: r = "all",
    exact: s,
    fetchStatus: n,
    predicate: i,
    queryKey: a,
    stale: l
  } = t;
  if (a) {
    if (s) {
      if (e.queryHash !== vr(a, e.options))
        return !1;
    } else if (!mt(e.queryKey, a))
      return !1;
  }
  if (r !== "all") {
    const f = e.isActive();
    if (r === "active" && !f || r === "inactive" && f)
      return !1;
  }
  return !(typeof l == "boolean" && e.isStale() !== l || n && n !== e.state.fetchStatus || i && !i(e));
}
function xr(t, e) {
  const { exact: r, status: s, predicate: n, mutationKey: i } = t;
  if (i) {
    if (!e.options.mutationKey)
      return !1;
    if (r) {
      if (Ne(e.options.mutationKey) !== Ne(i))
        return !1;
    } else if (!mt(e.options.mutationKey, i))
      return !1;
  }
  return !(s && e.state.status !== s || n && !n(e));
}
function vr(t, e) {
  return ((e == null ? void 0 : e.queryKeyHashFn) || Ne)(t);
}
function Ne(t) {
  return JSON.stringify(
    t,
    (e, r) => er(r) ? Object.keys(r).sort().reduce((s, n) => (s[n] = r[n], s), {}) : r
  );
}
function mt(t, e) {
  return t === e ? !0 : typeof t != typeof e ? !1 : t && e && typeof t == "object" && typeof e == "object" ? !Object.keys(e).some((r) => !mt(t[r], e[r])) : !1;
}
function Zt(t, e) {
  if (t === e)
    return t;
  const r = Nr(t) && Nr(e);
  if (r || er(t) && er(e)) {
    const s = r ? t : Object.keys(t), n = s.length, i = r ? e : Object.keys(e), a = i.length, l = r ? [] : {};
    let f = 0;
    for (let u = 0; u < a; u++) {
      const c = r ? u : i[u];
      (!r && s.includes(c) || r) && t[c] === void 0 && e[c] === void 0 ? (l[c] = void 0, f++) : (l[c] = Zt(t[c], e[c]), l[c] === t[c] && t[c] !== void 0 && f++);
    }
    return n === a && f === n ? t : l;
  }
  return e;
}
function Dt(t, e) {
  if (!e || Object.keys(t).length !== Object.keys(e).length)
    return !1;
  for (const r in t)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
function Nr(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function er(t) {
  if (!Lr(t))
    return !1;
  const e = t.constructor;
  if (e === void 0)
    return !0;
  const r = e.prototype;
  return !(!Lr(r) || !r.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(t) !== Object.prototype);
}
function Lr(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function _n(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
function tr(t, e, r) {
  if (typeof r.structuralSharing == "function")
    return r.structuralSharing(t, e);
  if (r.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return Zt(t, e);
      } catch (s) {
        console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${r.queryHash}]: ${s}`
        );
      }
    return Zt(t, e);
  }
  return e;
}
function qn(t, e, r = 0) {
  const s = [...t, e];
  return r && s.length > r ? s.slice(1) : s;
}
function jn(t, e, r = 0) {
  const s = [e, ...t];
  return r && s.length > r ? s.slice(0, -1) : s;
}
var At = Symbol();
function gs(t, e) {
  return process.env.NODE_ENV !== "production" && t.queryFn === At && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${t.queryHash}'`
  ), !t.queryFn && (e != null && e.initialPromise) ? () => e.initialPromise : !t.queryFn || t.queryFn === At ? () => Promise.reject(new Error(`Missing queryFn: '${t.queryHash}'`)) : t.queryFn;
}
var ve, he, _e, es, Bn = (es = class extends it {
  constructor() {
    super();
    S(this, ve);
    S(this, he);
    S(this, _e);
    b(this, _e, (e) => {
      if (!xe && window.addEventListener) {
        const r = () => e();
        return window.addEventListener("visibilitychange", r, !1), () => {
          window.removeEventListener("visibilitychange", r);
        };
      }
    });
  }
  onSubscribe() {
    o(this, he) || this.setEventListener(o(this, _e));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = o(this, he)) == null || e.call(this), b(this, he, void 0));
  }
  setEventListener(e) {
    var r;
    b(this, _e, e), (r = o(this, he)) == null || r.call(this), b(this, he, e((s) => {
      typeof s == "boolean" ? this.setFocused(s) : this.onFocus();
    }));
  }
  setFocused(e) {
    o(this, ve) !== e && (b(this, ve, e), this.onFocus());
  }
  onFocus() {
    const e = this.isFocused();
    this.listeners.forEach((r) => {
      r(e);
    });
  }
  isFocused() {
    var e;
    return typeof o(this, ve) == "boolean" ? o(this, ve) : ((e = globalThis.document) == null ? void 0 : e.visibilityState) !== "hidden";
  }
}, ve = new WeakMap(), he = new WeakMap(), _e = new WeakMap(), es), Pr = new Bn(), qe, fe, je, ts, Hn = (ts = class extends it {
  constructor() {
    super();
    S(this, qe, !0);
    S(this, fe);
    S(this, je);
    b(this, je, (e) => {
      if (!xe && window.addEventListener) {
        const r = () => e(!0), s = () => e(!1);
        return window.addEventListener("online", r, !1), window.addEventListener("offline", s, !1), () => {
          window.removeEventListener("online", r), window.removeEventListener("offline", s);
        };
      }
    });
  }
  onSubscribe() {
    o(this, fe) || this.setEventListener(o(this, je));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = o(this, fe)) == null || e.call(this), b(this, fe, void 0));
  }
  setEventListener(e) {
    var r;
    b(this, je, e), (r = o(this, fe)) == null || r.call(this), b(this, fe, e(this.setOnline.bind(this)));
  }
  setOnline(e) {
    o(this, qe) !== e && (b(this, qe, e), this.listeners.forEach((s) => {
      s(e);
    }));
  }
  isOnline() {
    return o(this, qe);
  }
}, qe = new WeakMap(), fe = new WeakMap(), je = new WeakMap(), ts), Ft = new Hn();
function rr() {
  let t, e;
  const r = new Promise((n, i) => {
    t = n, e = i;
  });
  r.status = "pending", r.catch(() => {
  });
  function s(n) {
    Object.assign(r, n), delete r.resolve, delete r.reject;
  }
  return r.resolve = (n) => {
    s({
      status: "fulfilled",
      value: n
    }), t(n);
  }, r.reject = (n) => {
    s({
      status: "rejected",
      reason: n
    }), e(n);
  }, r;
}
function Qn(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function ys(t) {
  return (t ?? "online") === "online" ? Ft.isOnline() : !0;
}
var ws = class extends Error {
  constructor(t) {
    super("CancelledError"), this.revert = t == null ? void 0 : t.revert, this.silent = t == null ? void 0 : t.silent;
  }
};
function zt(t) {
  return t instanceof ws;
}
function bs(t) {
  let e = !1, r = 0, s = !1, n;
  const i = rr(), a = (g) => {
    var p;
    s || (y(new ws(g)), (p = t.abort) == null || p.call(t));
  }, l = () => {
    e = !0;
  }, f = () => {
    e = !1;
  }, u = () => Pr.isFocused() && (t.networkMode === "always" || Ft.isOnline()) && t.canRun(), c = () => ys(t.networkMode) && t.canRun(), h = (g) => {
    var p;
    s || (s = !0, (p = t.onSuccess) == null || p.call(t, g), n == null || n(), i.resolve(g));
  }, y = (g) => {
    var p;
    s || (s = !0, (p = t.onError) == null || p.call(t, g), n == null || n(), i.reject(g));
  }, k = () => new Promise((g) => {
    var p;
    n = (v) => {
      (s || u()) && g(v);
    }, (p = t.onPause) == null || p.call(t);
  }).then(() => {
    var g;
    n = void 0, s || (g = t.onContinue) == null || g.call(t);
  }), w = () => {
    if (s)
      return;
    let g;
    const p = r === 0 ? t.initialPromise : void 0;
    try {
      g = p ?? t.fn();
    } catch (v) {
      g = Promise.reject(v);
    }
    Promise.resolve(g).then(h).catch((v) => {
      var L;
      if (s)
        return;
      const E = t.retry ?? (xe ? 0 : 3), P = t.retryDelay ?? Qn, F = typeof P == "function" ? P(r, v) : P, A = E === !0 || typeof E == "number" && r < E || typeof E == "function" && E(r, v);
      if (e || !A) {
        y(v);
        return;
      }
      r++, (L = t.onFail) == null || L.call(t, r, v), _n(F).then(() => u() ? void 0 : k()).then(() => {
        e ? y(v) : w();
      });
    });
  };
  return {
    promise: i,
    cancel: a,
    continue: () => (n == null || n(), i),
    cancelRetry: l,
    continueRetry: f,
    canStart: c,
    start: () => (c() ? w() : k().then(w), i)
  };
}
function zn() {
  let t = [], e = 0, r = (l) => {
    l();
  }, s = (l) => {
    l();
  }, n = (l) => setTimeout(l, 0);
  const i = (l) => {
    e ? t.push(l) : n(() => {
      r(l);
    });
  }, a = () => {
    const l = t;
    t = [], l.length && n(() => {
      s(() => {
        l.forEach((f) => {
          r(f);
        });
      });
    });
  };
  return {
    batch: (l) => {
      let f;
      e++;
      try {
        f = l();
      } finally {
        e--, e || a();
      }
      return f;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (l) => (...f) => {
      i(() => {
        l(...f);
      });
    },
    schedule: i,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (l) => {
      r = l;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (l) => {
      s = l;
    },
    setScheduler: (l) => {
      n = l;
    }
  };
}
var _ = zn(), Pe, rs, ks = (rs = class {
  constructor() {
    S(this, Pe);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), Xt(this.gcTime) && b(this, Pe, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(t) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      t ?? (xe ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    o(this, Pe) && (clearTimeout(o(this, Pe)), b(this, Pe, void 0));
  }
}, Pe = new WeakMap(), rs), Be, He, J, j, gt, Ee, X, oe, ss, Kn = (ss = class extends ks {
  constructor(e) {
    super();
    S(this, X);
    S(this, Be);
    S(this, He);
    S(this, J);
    S(this, j);
    S(this, gt);
    S(this, Ee);
    b(this, Ee, !1), b(this, gt, e.defaultOptions), this.setOptions(e.options), this.observers = [], b(this, J, e.cache), this.queryKey = e.queryKey, this.queryHash = e.queryHash, b(this, Be, Vn(this.options)), this.state = e.state ?? o(this, Be), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var e;
    return (e = o(this, j)) == null ? void 0 : e.promise;
  }
  setOptions(e) {
    this.options = { ...o(this, gt), ...e }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && o(this, J).remove(this);
  }
  setData(e, r) {
    const s = tr(this.state.data, e, this.options);
    return T(this, X, oe).call(this, {
      data: s,
      type: "success",
      dataUpdatedAt: r == null ? void 0 : r.updatedAt,
      manual: r == null ? void 0 : r.manual
    }), s;
  }
  setState(e, r) {
    T(this, X, oe).call(this, { type: "setState", state: e, setStateOptions: r });
  }
  cancel(e) {
    var s, n;
    const r = (s = o(this, j)) == null ? void 0 : s.promise;
    return (n = o(this, j)) == null || n.cancel(e), r ? r.then(Y).catch(Y) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(o(this, Be));
  }
  isActive() {
    return this.observers.some(
      (e) => ee(e.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === At || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (e) => e.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !ps(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var r;
    const e = this.observers.find((s) => s.shouldFetchOnWindowFocus());
    e == null || e.refetch({ cancelRefetch: !1 }), (r = o(this, j)) == null || r.continue();
  }
  onOnline() {
    var r;
    const e = this.observers.find((s) => s.shouldFetchOnReconnect());
    e == null || e.refetch({ cancelRefetch: !1 }), (r = o(this, j)) == null || r.continue();
  }
  addObserver(e) {
    this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), o(this, J).notify({ type: "observerAdded", query: this, observer: e }));
  }
  removeObserver(e) {
    this.observers.includes(e) && (this.observers = this.observers.filter((r) => r !== e), this.observers.length || (o(this, j) && (o(this, Ee) ? o(this, j).cancel({ revert: !0 }) : o(this, j).cancelRetry()), this.scheduleGc()), o(this, J).notify({ type: "observerRemoved", query: this, observer: e }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || T(this, X, oe).call(this, { type: "invalidate" });
  }
  fetch(e, r) {
    var f, u, c;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (r != null && r.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (o(this, j))
        return o(this, j).continueRetry(), o(this, j).promise;
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const h = this.observers.find((y) => y.options.queryFn);
      h && this.setOptions(h.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const s = new AbortController(), n = (h) => {
      Object.defineProperty(h, "signal", {
        enumerable: !0,
        get: () => (b(this, Ee, !0), s.signal)
      });
    }, i = () => {
      const h = gs(this.options, r), y = {
        queryKey: this.queryKey,
        meta: this.meta
      };
      return n(y), b(this, Ee, !1), this.options.persister ? this.options.persister(
        h,
        y,
        this
      ) : h(y);
    }, a = {
      fetchOptions: r,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: i
    };
    n(a), (f = this.options.behavior) == null || f.onFetch(
      a,
      this
    ), b(this, He, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((u = a.fetchOptions) == null ? void 0 : u.meta)) && T(this, X, oe).call(this, { type: "fetch", meta: (c = a.fetchOptions) == null ? void 0 : c.meta });
    const l = (h) => {
      var y, k, w, g;
      zt(h) && h.silent || T(this, X, oe).call(this, {
        type: "error",
        error: h
      }), zt(h) || ((k = (y = o(this, J).config).onError) == null || k.call(
        y,
        h,
        this
      ), (g = (w = o(this, J).config).onSettled) == null || g.call(
        w,
        this.state.data,
        h,
        this
      )), this.scheduleGc();
    };
    return b(this, j, bs({
      initialPromise: r == null ? void 0 : r.initialPromise,
      fn: a.fetchFn,
      abort: s.abort.bind(s),
      onSuccess: (h) => {
        var y, k, w, g;
        if (h === void 0) {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), l(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(h);
        } catch (p) {
          l(p);
          return;
        }
        (k = (y = o(this, J).config).onSuccess) == null || k.call(y, h, this), (g = (w = o(this, J).config).onSettled) == null || g.call(
          w,
          h,
          this.state.error,
          this
        ), this.scheduleGc();
      },
      onError: l,
      onFail: (h, y) => {
        T(this, X, oe).call(this, { type: "failed", failureCount: h, error: y });
      },
      onPause: () => {
        T(this, X, oe).call(this, { type: "pause" });
      },
      onContinue: () => {
        T(this, X, oe).call(this, { type: "continue" });
      },
      retry: a.options.retry,
      retryDelay: a.options.retryDelay,
      networkMode: a.options.networkMode,
      canRun: () => !0
    })), o(this, j).start();
  }
}, Be = new WeakMap(), He = new WeakMap(), J = new WeakMap(), j = new WeakMap(), gt = new WeakMap(), Ee = new WeakMap(), X = new WeakSet(), oe = function(e) {
  const r = (s) => {
    switch (e.type) {
      case "failed":
        return {
          ...s,
          fetchFailureCount: e.failureCount,
          fetchFailureReason: e.error
        };
      case "pause":
        return {
          ...s,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...s,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...s,
          ...Ss(s.data, this.options),
          fetchMeta: e.meta ?? null
        };
      case "success":
        return {
          ...s,
          data: e.data,
          dataUpdateCount: s.dataUpdateCount + 1,
          dataUpdatedAt: e.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!e.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const n = e.error;
        return zt(n) && n.revert && o(this, He) ? { ...o(this, He), fetchStatus: "idle" } : {
          ...s,
          error: n,
          errorUpdateCount: s.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: s.fetchFailureCount + 1,
          fetchFailureReason: n,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...s,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...s,
          ...e.state
        };
    }
  };
  this.state = r(this.state), _.batch(() => {
    this.observers.forEach((s) => {
      s.onQueryUpdate();
    }), o(this, J).notify({ query: this, type: "updated", action: e });
  });
}, ss);
function Ss(t, e) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: ys(e.networkMode) ? "fetching" : "paused",
    ...t === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function Vn(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData, r = e !== void 0, s = r ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: r ? s ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: r ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var se, ns, Wn = (ns = class extends it {
  constructor(e = {}) {
    super();
    S(this, se);
    this.config = e, b(this, se, /* @__PURE__ */ new Map());
  }
  build(e, r, s) {
    const n = r.queryKey, i = r.queryHash ?? vr(n, r);
    let a = this.get(i);
    return a || (a = new Kn({
      cache: this,
      queryKey: n,
      queryHash: i,
      options: e.defaultQueryOptions(r),
      state: s,
      defaultOptions: e.getQueryDefaults(n)
    }), this.add(a)), a;
  }
  add(e) {
    o(this, se).has(e.queryHash) || (o(this, se).set(e.queryHash, e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const r = o(this, se).get(e.queryHash);
    r && (e.destroy(), r === e && o(this, se).delete(e.queryHash), this.notify({ type: "removed", query: e }));
  }
  clear() {
    _.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return o(this, se).get(e);
  }
  getAll() {
    return [...o(this, se).values()];
  }
  find(e) {
    const r = { exact: !0, ...e };
    return this.getAll().find(
      (s) => Fr(r, s)
    );
  }
  findAll(e = {}) {
    const r = this.getAll();
    return Object.keys(e).length > 0 ? r.filter((s) => Fr(e, s)) : r;
  }
  notify(e) {
    _.batch(() => {
      this.listeners.forEach((r) => {
        r(e);
      });
    });
  }
  onFocus() {
    _.batch(() => {
      this.getAll().forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    _.batch(() => {
      this.getAll().forEach((e) => {
        e.onOnline();
      });
    });
  }
}, se = new WeakMap(), ns), ne, H, Re, ie, de, is, Gn = (is = class extends ks {
  constructor(e) {
    super();
    S(this, ie);
    S(this, ne);
    S(this, H);
    S(this, Re);
    this.mutationId = e.mutationId, b(this, H, e.mutationCache), b(this, ne, []), this.state = e.state || vs(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = e, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(e) {
    o(this, ne).includes(e) || (o(this, ne).push(e), this.clearGcTimeout(), o(this, H).notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    b(this, ne, o(this, ne).filter((r) => r !== e)), this.scheduleGc(), o(this, H).notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    o(this, ne).length || (this.state.status === "pending" ? this.scheduleGc() : o(this, H).remove(this));
  }
  continue() {
    var e;
    return ((e = o(this, Re)) == null ? void 0 : e.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(e) {
    var n, i, a, l, f, u, c, h, y, k, w, g, p, v, E, P, F, A, L, D;
    b(this, Re, bs({
      fn: () => this.options.mutationFn ? this.options.mutationFn(e) : Promise.reject(new Error("No mutationFn found")),
      onFail: (N, R) => {
        T(this, ie, de).call(this, { type: "failed", failureCount: N, error: R });
      },
      onPause: () => {
        T(this, ie, de).call(this, { type: "pause" });
      },
      onContinue: () => {
        T(this, ie, de).call(this, { type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => o(this, H).canRun(this)
    }));
    const r = this.state.status === "pending", s = !o(this, Re).canStart();
    try {
      if (!r) {
        T(this, ie, de).call(this, { type: "pending", variables: e, isPaused: s }), await ((i = (n = o(this, H).config).onMutate) == null ? void 0 : i.call(
          n,
          e,
          this
        ));
        const R = await ((l = (a = this.options).onMutate) == null ? void 0 : l.call(a, e));
        R !== this.state.context && T(this, ie, de).call(this, {
          type: "pending",
          context: R,
          variables: e,
          isPaused: s
        });
      }
      const N = await o(this, Re).start();
      return await ((u = (f = o(this, H).config).onSuccess) == null ? void 0 : u.call(
        f,
        N,
        e,
        this.state.context,
        this
      )), await ((h = (c = this.options).onSuccess) == null ? void 0 : h.call(c, N, e, this.state.context)), await ((k = (y = o(this, H).config).onSettled) == null ? void 0 : k.call(
        y,
        N,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((g = (w = this.options).onSettled) == null ? void 0 : g.call(w, N, null, e, this.state.context)), T(this, ie, de).call(this, { type: "success", data: N }), N;
    } catch (N) {
      try {
        throw await ((v = (p = o(this, H).config).onError) == null ? void 0 : v.call(
          p,
          N,
          e,
          this.state.context,
          this
        )), await ((P = (E = this.options).onError) == null ? void 0 : P.call(
          E,
          N,
          e,
          this.state.context
        )), await ((A = (F = o(this, H).config).onSettled) == null ? void 0 : A.call(
          F,
          void 0,
          N,
          this.state.variables,
          this.state.context,
          this
        )), await ((D = (L = this.options).onSettled) == null ? void 0 : D.call(
          L,
          void 0,
          N,
          e,
          this.state.context
        )), N;
      } finally {
        T(this, ie, de).call(this, { type: "error", error: N });
      }
    } finally {
      o(this, H).runNext(this);
    }
  }
}, ne = new WeakMap(), H = new WeakMap(), Re = new WeakMap(), ie = new WeakSet(), de = function(e) {
  const r = (s) => {
    switch (e.type) {
      case "failed":
        return {
          ...s,
          failureCount: e.failureCount,
          failureReason: e.error
        };
      case "pause":
        return {
          ...s,
          isPaused: !0
        };
      case "continue":
        return {
          ...s,
          isPaused: !1
        };
      case "pending":
        return {
          ...s,
          context: e.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: e.isPaused,
          status: "pending",
          variables: e.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...s,
          data: e.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...s,
          data: void 0,
          error: e.error,
          failureCount: s.failureCount + 1,
          failureReason: e.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = r(this.state), _.batch(() => {
    o(this, ne).forEach((s) => {
      s.onMutationUpdate(e);
    }), o(this, H).notify({
      mutation: this,
      type: "updated",
      action: e
    });
  });
}, is);
function vs() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var le, Z, yt, as, $n = (as = class extends it {
  constructor(e = {}) {
    super();
    S(this, le);
    S(this, Z);
    S(this, yt);
    this.config = e, b(this, le, /* @__PURE__ */ new Set()), b(this, Z, /* @__PURE__ */ new Map()), b(this, yt, 0);
  }
  build(e, r, s) {
    const n = new Gn({
      mutationCache: this,
      mutationId: ++Pt(this, yt)._,
      options: e.defaultMutationOptions(r),
      state: s
    });
    return this.add(n), n;
  }
  add(e) {
    o(this, le).add(e);
    const r = Et(e);
    if (typeof r == "string") {
      const s = o(this, Z).get(r);
      s ? s.push(e) : o(this, Z).set(r, [e]);
    }
    this.notify({ type: "added", mutation: e });
  }
  remove(e) {
    if (o(this, le).delete(e)) {
      const r = Et(e);
      if (typeof r == "string") {
        const s = o(this, Z).get(r);
        if (s)
          if (s.length > 1) {
            const n = s.indexOf(e);
            n !== -1 && s.splice(n, 1);
          } else s[0] === e && o(this, Z).delete(r);
      }
    }
    this.notify({ type: "removed", mutation: e });
  }
  canRun(e) {
    const r = Et(e);
    if (typeof r == "string") {
      const s = o(this, Z).get(r), n = s == null ? void 0 : s.find(
        (i) => i.state.status === "pending"
      );
      return !n || n === e;
    } else
      return !0;
  }
  runNext(e) {
    var s;
    const r = Et(e);
    if (typeof r == "string") {
      const n = (s = o(this, Z).get(r)) == null ? void 0 : s.find((i) => i !== e && i.state.isPaused);
      return (n == null ? void 0 : n.continue()) ?? Promise.resolve();
    } else
      return Promise.resolve();
  }
  clear() {
    _.batch(() => {
      o(this, le).forEach((e) => {
        this.notify({ type: "removed", mutation: e });
      }), o(this, le).clear(), o(this, Z).clear();
    });
  }
  getAll() {
    return Array.from(o(this, le));
  }
  find(e) {
    const r = { exact: !0, ...e };
    return this.getAll().find(
      (s) => xr(r, s)
    );
  }
  findAll(e = {}) {
    return this.getAll().filter((r) => xr(e, r));
  }
  notify(e) {
    _.batch(() => {
      this.listeners.forEach((r) => {
        r(e);
      });
    });
  }
  resumePausedMutations() {
    const e = this.getAll().filter((r) => r.state.isPaused);
    return _.batch(
      () => Promise.all(
        e.map((r) => r.continue().catch(Y))
      )
    );
  }
}, le = new WeakMap(), Z = new WeakMap(), yt = new WeakMap(), as);
function Et(t) {
  var e;
  return (e = t.options.scope) == null ? void 0 : e.id;
}
function Ir(t) {
  return {
    onFetch: (e, r) => {
      var c, h, y, k, w;
      const s = e.options, n = (y = (h = (c = e.fetchOptions) == null ? void 0 : c.meta) == null ? void 0 : h.fetchMore) == null ? void 0 : y.direction, i = ((k = e.state.data) == null ? void 0 : k.pages) || [], a = ((w = e.state.data) == null ? void 0 : w.pageParams) || [];
      let l = { pages: [], pageParams: [] }, f = 0;
      const u = async () => {
        let g = !1;
        const p = (P) => {
          Object.defineProperty(P, "signal", {
            enumerable: !0,
            get: () => (e.signal.aborted ? g = !0 : e.signal.addEventListener("abort", () => {
              g = !0;
            }), e.signal)
          });
        }, v = gs(e.options, e.fetchOptions), E = async (P, F, A) => {
          if (g)
            return Promise.reject();
          if (F == null && P.pages.length)
            return Promise.resolve(P);
          const L = {
            queryKey: e.queryKey,
            pageParam: F,
            direction: A ? "backward" : "forward",
            meta: e.options.meta
          };
          p(L);
          const D = await v(
            L
          ), { maxPages: N } = e.options, R = A ? jn : qn;
          return {
            pages: R(P.pages, D, N),
            pageParams: R(P.pageParams, F, N)
          };
        };
        if (n && i.length) {
          const P = n === "backward", F = P ? Jn : Mr, A = {
            pages: i,
            pageParams: a
          }, L = F(s, A);
          l = await E(A, L, P);
        } else {
          const P = t ?? i.length;
          do {
            const F = f === 0 ? a[0] ?? s.initialPageParam : Mr(s, l);
            if (f > 0 && F == null)
              break;
            l = await E(l, F), f++;
          } while (f < P);
        }
        return l;
      };
      e.options.persister ? e.fetchFn = () => {
        var g, p;
        return (p = (g = e.options).persister) == null ? void 0 : p.call(
          g,
          u,
          {
            queryKey: e.queryKey,
            meta: e.options.meta,
            signal: e.signal
          },
          r
        );
      } : e.fetchFn = u;
    }
  };
}
function Mr(t, { pages: e, pageParams: r }) {
  const s = e.length - 1;
  return e.length > 0 ? t.getNextPageParam(
    e[s],
    e,
    r[s],
    r
  ) : void 0;
}
function Jn(t, { pages: e, pageParams: r }) {
  var s;
  return e.length > 0 ? (s = t.getPreviousPageParam) == null ? void 0 : s.call(t, e[0], e, r[0], r) : void 0;
}
var I, me, pe, Qe, ze, ge, Ke, Ve, os, Yn = (os = class {
  constructor(t = {}) {
    S(this, I);
    S(this, me);
    S(this, pe);
    S(this, Qe);
    S(this, ze);
    S(this, ge);
    S(this, Ke);
    S(this, Ve);
    b(this, I, t.queryCache || new Wn()), b(this, me, t.mutationCache || new $n()), b(this, pe, t.defaultOptions || {}), b(this, Qe, /* @__PURE__ */ new Map()), b(this, ze, /* @__PURE__ */ new Map()), b(this, ge, 0);
  }
  mount() {
    Pt(this, ge)._++, o(this, ge) === 1 && (b(this, Ke, Pr.subscribe(async (t) => {
      t && (await this.resumePausedMutations(), o(this, I).onFocus());
    })), b(this, Ve, Ft.subscribe(async (t) => {
      t && (await this.resumePausedMutations(), o(this, I).onOnline());
    })));
  }
  unmount() {
    var t, e;
    Pt(this, ge)._--, o(this, ge) === 0 && ((t = o(this, Ke)) == null || t.call(this), b(this, Ke, void 0), (e = o(this, Ve)) == null || e.call(this), b(this, Ve, void 0));
  }
  isFetching(t) {
    return o(this, I).findAll({ ...t, fetchStatus: "fetching" }).length;
  }
  isMutating(t) {
    return o(this, me).findAll({ ...t, status: "pending" }).length;
  }
  getQueryData(t) {
    var r;
    const e = this.defaultQueryOptions({ queryKey: t });
    return (r = o(this, I).get(e.queryHash)) == null ? void 0 : r.state.data;
  }
  ensureQueryData(t) {
    const e = this.defaultQueryOptions(t), r = o(this, I).build(this, e), s = r.state.data;
    return s === void 0 ? this.fetchQuery(t) : (t.revalidateIfStale && r.isStaleByTime(Ue(e.staleTime, r)) && this.prefetchQuery(e), Promise.resolve(s));
  }
  getQueriesData(t) {
    return o(this, I).findAll(t).map(({ queryKey: e, state: r }) => {
      const s = r.data;
      return [e, s];
    });
  }
  setQueryData(t, e, r) {
    const s = this.defaultQueryOptions({ queryKey: t }), n = o(this, I).get(
      s.queryHash
    ), i = n == null ? void 0 : n.state.data, a = Un(e, i);
    if (a !== void 0)
      return o(this, I).build(this, s).setData(a, { ...r, manual: !0 });
  }
  setQueriesData(t, e, r) {
    return _.batch(
      () => o(this, I).findAll(t).map(({ queryKey: s }) => [
        s,
        this.setQueryData(s, e, r)
      ])
    );
  }
  getQueryState(t) {
    var r;
    const e = this.defaultQueryOptions({ queryKey: t });
    return (r = o(this, I).get(
      e.queryHash
    )) == null ? void 0 : r.state;
  }
  removeQueries(t) {
    const e = o(this, I);
    _.batch(() => {
      e.findAll(t).forEach((r) => {
        e.remove(r);
      });
    });
  }
  resetQueries(t, e) {
    const r = o(this, I), s = {
      type: "active",
      ...t
    };
    return _.batch(() => (r.findAll(t).forEach((n) => {
      n.reset();
    }), this.refetchQueries(s, e)));
  }
  cancelQueries(t, e = {}) {
    const r = { revert: !0, ...e }, s = _.batch(
      () => o(this, I).findAll(t).map((n) => n.cancel(r))
    );
    return Promise.all(s).then(Y).catch(Y);
  }
  invalidateQueries(t, e = {}) {
    return _.batch(() => {
      if (o(this, I).findAll(t).forEach((s) => {
        s.invalidate();
      }), (t == null ? void 0 : t.refetchType) === "none")
        return Promise.resolve();
      const r = {
        ...t,
        type: (t == null ? void 0 : t.refetchType) ?? (t == null ? void 0 : t.type) ?? "active"
      };
      return this.refetchQueries(r, e);
    });
  }
  refetchQueries(t, e = {}) {
    const r = {
      ...e,
      cancelRefetch: e.cancelRefetch ?? !0
    }, s = _.batch(
      () => o(this, I).findAll(t).filter((n) => !n.isDisabled()).map((n) => {
        let i = n.fetch(void 0, r);
        return r.throwOnError || (i = i.catch(Y)), n.state.fetchStatus === "paused" ? Promise.resolve() : i;
      })
    );
    return Promise.all(s).then(Y);
  }
  fetchQuery(t) {
    const e = this.defaultQueryOptions(t);
    e.retry === void 0 && (e.retry = !1);
    const r = o(this, I).build(this, e);
    return r.isStaleByTime(
      Ue(e.staleTime, r)
    ) ? r.fetch(e) : Promise.resolve(r.state.data);
  }
  prefetchQuery(t) {
    return this.fetchQuery(t).then(Y).catch(Y);
  }
  fetchInfiniteQuery(t) {
    return t.behavior = Ir(t.pages), this.fetchQuery(t);
  }
  prefetchInfiniteQuery(t) {
    return this.fetchInfiniteQuery(t).then(Y).catch(Y);
  }
  ensureInfiniteQueryData(t) {
    return t.behavior = Ir(t.pages), this.ensureQueryData(t);
  }
  resumePausedMutations() {
    return Ft.isOnline() ? o(this, me).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return o(this, I);
  }
  getMutationCache() {
    return o(this, me);
  }
  getDefaultOptions() {
    return o(this, pe);
  }
  setDefaultOptions(t) {
    b(this, pe, t);
  }
  setQueryDefaults(t, e) {
    o(this, Qe).set(Ne(t), {
      queryKey: t,
      defaultOptions: e
    });
  }
  getQueryDefaults(t) {
    const e = [...o(this, Qe).values()], r = {};
    return e.forEach((s) => {
      mt(t, s.queryKey) && Object.assign(r, s.defaultOptions);
    }), r;
  }
  setMutationDefaults(t, e) {
    o(this, ze).set(Ne(t), {
      mutationKey: t,
      defaultOptions: e
    });
  }
  getMutationDefaults(t) {
    const e = [...o(this, ze).values()];
    let r = {};
    return e.forEach((s) => {
      mt(t, s.mutationKey) && (r = { ...r, ...s.defaultOptions });
    }), r;
  }
  defaultQueryOptions(t) {
    if (t._defaulted)
      return t;
    const e = {
      ...o(this, pe).queries,
      ...this.getQueryDefaults(t.queryKey),
      ...t,
      _defaulted: !0
    };
    return e.queryHash || (e.queryHash = vr(
      e.queryKey,
      e
    )), e.refetchOnReconnect === void 0 && (e.refetchOnReconnect = e.networkMode !== "always"), e.throwOnError === void 0 && (e.throwOnError = !!e.suspense), !e.networkMode && e.persister && (e.networkMode = "offlineFirst"), e.queryFn === At && (e.enabled = !1), e;
  }
  defaultMutationOptions(t) {
    return t != null && t._defaulted ? t : {
      ...o(this, pe).mutations,
      ...(t == null ? void 0 : t.mutationKey) && this.getMutationDefaults(t.mutationKey),
      ...t,
      _defaulted: !0
    };
  }
  clear() {
    o(this, I).clear(), o(this, me).clear();
  }
}, I = new WeakMap(), me = new WeakMap(), pe = new WeakMap(), Qe = new WeakMap(), ze = new WeakMap(), ge = new WeakMap(), Ke = new WeakMap(), Ve = new WeakMap(), os), K, O, wt, Q, Ce, We, ye, ae, bt, Ge, $e, Te, Oe, we, Je, x, ct, sr, nr, ir, ar, or, lr, ur, Ps, ls, Xn = (ls = class extends it {
  constructor(e, r) {
    super();
    S(this, x);
    S(this, K);
    S(this, O);
    S(this, wt);
    S(this, Q);
    S(this, Ce);
    S(this, We);
    S(this, ye);
    S(this, ae);
    S(this, bt);
    S(this, Ge);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    S(this, $e);
    S(this, Te);
    S(this, Oe);
    S(this, we);
    S(this, Je, /* @__PURE__ */ new Set());
    this.options = r, b(this, K, e), b(this, ae, null), b(this, ye, rr()), this.options.experimental_prefetchInRender || o(this, ye).reject(
      new Error("experimental_prefetchInRender feature flag is not enabled")
    ), this.bindMethods(), this.setOptions(r);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (o(this, O).addObserver(this), Ur(o(this, O), this.options) ? T(this, x, ct).call(this) : this.updateResult(), T(this, x, ar).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return cr(
      o(this, O),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return cr(
      o(this, O),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), T(this, x, or).call(this), T(this, x, lr).call(this), o(this, O).removeObserver(this);
  }
  setOptions(e, r) {
    const s = this.options, n = o(this, O);
    if (this.options = o(this, K).defaultQueryOptions(e), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof ee(this.options.enabled, o(this, O)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    T(this, x, ur).call(this), o(this, O).setOptions(this.options), s._defaulted && !Dt(this.options, s) && o(this, K).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: o(this, O),
      observer: this
    });
    const i = this.hasListeners();
    i && _r(
      o(this, O),
      n,
      this.options,
      s
    ) && T(this, x, ct).call(this), this.updateResult(r), i && (o(this, O) !== n || ee(this.options.enabled, o(this, O)) !== ee(s.enabled, o(this, O)) || Ue(this.options.staleTime, o(this, O)) !== Ue(s.staleTime, o(this, O))) && T(this, x, sr).call(this);
    const a = T(this, x, nr).call(this);
    i && (o(this, O) !== n || ee(this.options.enabled, o(this, O)) !== ee(s.enabled, o(this, O)) || a !== o(this, we)) && T(this, x, ir).call(this, a);
  }
  getOptimisticResult(e) {
    const r = o(this, K).getQueryCache().build(o(this, K), e), s = this.createResult(r, e);
    return ei(this, s) && (b(this, Q, s), b(this, We, this.options), b(this, Ce, o(this, O).state)), s;
  }
  getCurrentResult() {
    return o(this, Q);
  }
  trackResult(e, r) {
    const s = {};
    return Object.keys(e).forEach((n) => {
      Object.defineProperty(s, n, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackProp(n), r == null || r(n), e[n])
      });
    }), s;
  }
  trackProp(e) {
    o(this, Je).add(e);
  }
  getCurrentQuery() {
    return o(this, O);
  }
  refetch({ ...e } = {}) {
    return this.fetch({
      ...e
    });
  }
  fetchOptimistic(e) {
    const r = o(this, K).defaultQueryOptions(e), s = o(this, K).getQueryCache().build(o(this, K), r);
    return s.fetch().then(() => this.createResult(s, r));
  }
  fetch(e) {
    return T(this, x, ct).call(this, {
      ...e,
      cancelRefetch: e.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), o(this, Q)));
  }
  createResult(e, r) {
    var N;
    const s = o(this, O), n = this.options, i = o(this, Q), a = o(this, Ce), l = o(this, We), u = e !== s ? e.state : o(this, wt), { state: c } = e;
    let h = { ...c }, y = !1, k;
    if (r._optimisticResults) {
      const R = this.hasListeners(), Ie = !R && Ur(e, r), Me = R && _r(e, s, r, n);
      (Ie || Me) && (h = {
        ...h,
        ...Ss(c.data, e.options)
      }), r._optimisticResults === "isRestoring" && (h.fetchStatus = "idle");
    }
    let { error: w, errorUpdatedAt: g, status: p } = h;
    if (r.select && h.data !== void 0)
      if (i && h.data === (a == null ? void 0 : a.data) && r.select === o(this, bt))
        k = o(this, Ge);
      else
        try {
          b(this, bt, r.select), k = r.select(h.data), k = tr(i == null ? void 0 : i.data, k, r), b(this, Ge, k), b(this, ae, null);
        } catch (R) {
          b(this, ae, R);
        }
    else
      k = h.data;
    if (r.placeholderData !== void 0 && k === void 0 && p === "pending") {
      let R;
      if (i != null && i.isPlaceholderData && r.placeholderData === (l == null ? void 0 : l.placeholderData))
        R = i.data;
      else if (R = typeof r.placeholderData == "function" ? r.placeholderData(
        (N = o(this, $e)) == null ? void 0 : N.state.data,
        o(this, $e)
      ) : r.placeholderData, r.select && R !== void 0)
        try {
          R = r.select(R), b(this, ae, null);
        } catch (Ie) {
          b(this, ae, Ie);
        }
      R !== void 0 && (p = "success", k = tr(
        i == null ? void 0 : i.data,
        R,
        r
      ), y = !0);
    }
    o(this, ae) && (w = o(this, ae), k = o(this, Ge), g = Date.now(), p = "error");
    const v = h.fetchStatus === "fetching", E = p === "pending", P = p === "error", F = E && v, A = k !== void 0, D = {
      status: p,
      fetchStatus: h.fetchStatus,
      isPending: E,
      isSuccess: p === "success",
      isError: P,
      isInitialLoading: F,
      isLoading: F,
      data: k,
      dataUpdatedAt: h.dataUpdatedAt,
      error: w,
      errorUpdatedAt: g,
      failureCount: h.fetchFailureCount,
      failureReason: h.fetchFailureReason,
      errorUpdateCount: h.errorUpdateCount,
      isFetched: h.dataUpdateCount > 0 || h.errorUpdateCount > 0,
      isFetchedAfterMount: h.dataUpdateCount > u.dataUpdateCount || h.errorUpdateCount > u.errorUpdateCount,
      isFetching: v,
      isRefetching: v && !E,
      isLoadingError: P && !A,
      isPaused: h.fetchStatus === "paused",
      isPlaceholderData: y,
      isRefetchError: P && A,
      isStale: Er(e, r),
      refetch: this.refetch,
      promise: o(this, ye)
    };
    if (this.options.experimental_prefetchInRender) {
      const R = (vt) => {
        D.status === "error" ? vt.reject(D.error) : D.data !== void 0 && vt.resolve(D.data);
      }, Ie = () => {
        const vt = b(this, ye, D.promise = rr());
        R(vt);
      }, Me = o(this, ye);
      switch (Me.status) {
        case "pending":
          e.queryHash === s.queryHash && R(Me);
          break;
        case "fulfilled":
          (D.status === "error" || D.data !== Me.value) && Ie();
          break;
        case "rejected":
          (D.status !== "error" || D.error !== Me.reason) && Ie();
          break;
      }
    }
    return D;
  }
  updateResult(e) {
    const r = o(this, Q), s = this.createResult(o(this, O), this.options);
    if (b(this, Ce, o(this, O).state), b(this, We, this.options), o(this, Ce).data !== void 0 && b(this, $e, o(this, O)), Dt(s, r))
      return;
    b(this, Q, s);
    const n = {}, i = () => {
      if (!r)
        return !0;
      const { notifyOnChangeProps: a } = this.options, l = typeof a == "function" ? a() : a;
      if (l === "all" || !l && !o(this, Je).size)
        return !0;
      const f = new Set(
        l ?? o(this, Je)
      );
      return this.options.throwOnError && f.add("error"), Object.keys(o(this, Q)).some((u) => {
        const c = u;
        return o(this, Q)[c] !== r[c] && f.has(c);
      });
    };
    (e == null ? void 0 : e.listeners) !== !1 && i() && (n.listeners = !0), T(this, x, Ps).call(this, { ...n, ...e });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && T(this, x, ar).call(this);
  }
}, K = new WeakMap(), O = new WeakMap(), wt = new WeakMap(), Q = new WeakMap(), Ce = new WeakMap(), We = new WeakMap(), ye = new WeakMap(), ae = new WeakMap(), bt = new WeakMap(), Ge = new WeakMap(), $e = new WeakMap(), Te = new WeakMap(), Oe = new WeakMap(), we = new WeakMap(), Je = new WeakMap(), x = new WeakSet(), ct = function(e) {
  T(this, x, ur).call(this);
  let r = o(this, O).fetch(
    this.options,
    e
  );
  return e != null && e.throwOnError || (r = r.catch(Y)), r;
}, sr = function() {
  T(this, x, or).call(this);
  const e = Ue(
    this.options.staleTime,
    o(this, O)
  );
  if (xe || o(this, Q).isStale || !Xt(e))
    return;
  const s = ps(o(this, Q).dataUpdatedAt, e) + 1;
  b(this, Te, setTimeout(() => {
    o(this, Q).isStale || this.updateResult();
  }, s));
}, nr = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(o(this, O)) : this.options.refetchInterval) ?? !1;
}, ir = function(e) {
  T(this, x, lr).call(this), b(this, we, e), !(xe || ee(this.options.enabled, o(this, O)) === !1 || !Xt(o(this, we)) || o(this, we) === 0) && b(this, Oe, setInterval(() => {
    (this.options.refetchIntervalInBackground || Pr.isFocused()) && T(this, x, ct).call(this);
  }, o(this, we)));
}, ar = function() {
  T(this, x, sr).call(this), T(this, x, ir).call(this, T(this, x, nr).call(this));
}, or = function() {
  o(this, Te) && (clearTimeout(o(this, Te)), b(this, Te, void 0));
}, lr = function() {
  o(this, Oe) && (clearInterval(o(this, Oe)), b(this, Oe, void 0));
}, ur = function() {
  const e = o(this, K).getQueryCache().build(o(this, K), this.options);
  if (e === o(this, O))
    return;
  const r = o(this, O);
  b(this, O, e), b(this, wt, e.state), this.hasListeners() && (r == null || r.removeObserver(this), e.addObserver(this));
}, Ps = function(e) {
  _.batch(() => {
    e.listeners && this.listeners.forEach((r) => {
      r(o(this, Q));
    }), o(this, K).getQueryCache().notify({
      query: o(this, O),
      type: "observerResultsUpdated"
    });
  });
}, ls);
function Zn(t, e) {
  return ee(e.enabled, t) !== !1 && t.state.data === void 0 && !(t.state.status === "error" && e.retryOnMount === !1);
}
function Ur(t, e) {
  return Zn(t, e) || t.state.data !== void 0 && cr(t, e, e.refetchOnMount);
}
function cr(t, e, r) {
  if (ee(e.enabled, t) !== !1) {
    const s = typeof r == "function" ? r(t) : r;
    return s === "always" || s !== !1 && Er(t, e);
  }
  return !1;
}
function _r(t, e, r, s) {
  return (t !== e || ee(s.enabled, t) === !1) && (!r.suspense || t.state.status !== "error") && Er(t, r);
}
function Er(t, e) {
  return ee(e.enabled, t) !== !1 && t.isStaleByTime(Ue(e.staleTime, t));
}
function ei(t, e) {
  return !Dt(t.getCurrentResult(), e);
}
var be, ke, V, ue, ce, Rt, dr, us, ti = (us = class extends it {
  constructor(e, r) {
    super();
    S(this, ce);
    S(this, be);
    S(this, ke);
    S(this, V);
    S(this, ue);
    b(this, be, e), this.setOptions(r), this.bindMethods(), T(this, ce, Rt).call(this);
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(e) {
    var s;
    const r = this.options;
    this.options = o(this, be).defaultMutationOptions(e), Dt(this.options, r) || o(this, be).getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: o(this, V),
      observer: this
    }), r != null && r.mutationKey && this.options.mutationKey && Ne(r.mutationKey) !== Ne(this.options.mutationKey) ? this.reset() : ((s = o(this, V)) == null ? void 0 : s.state.status) === "pending" && o(this, V).setOptions(this.options);
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || (e = o(this, V)) == null || e.removeObserver(this);
  }
  onMutationUpdate(e) {
    T(this, ce, Rt).call(this), T(this, ce, dr).call(this, e);
  }
  getCurrentResult() {
    return o(this, ke);
  }
  reset() {
    var e;
    (e = o(this, V)) == null || e.removeObserver(this), b(this, V, void 0), T(this, ce, Rt).call(this), T(this, ce, dr).call(this);
  }
  mutate(e, r) {
    var s;
    return b(this, ue, r), (s = o(this, V)) == null || s.removeObserver(this), b(this, V, o(this, be).getMutationCache().build(o(this, be), this.options)), o(this, V).addObserver(this), o(this, V).execute(e);
  }
}, be = new WeakMap(), ke = new WeakMap(), V = new WeakMap(), ue = new WeakMap(), ce = new WeakSet(), Rt = function() {
  var r;
  const e = ((r = o(this, V)) == null ? void 0 : r.state) ?? vs();
  b(this, ke, {
    ...e,
    isPending: e.status === "pending",
    isSuccess: e.status === "success",
    isError: e.status === "error",
    isIdle: e.status === "idle",
    mutate: this.mutate,
    reset: this.reset
  });
}, dr = function(e) {
  _.batch(() => {
    var r, s, n, i, a, l, f, u;
    if (o(this, ue) && this.hasListeners()) {
      const c = o(this, ke).variables, h = o(this, ke).context;
      (e == null ? void 0 : e.type) === "success" ? ((s = (r = o(this, ue)).onSuccess) == null || s.call(r, e.data, c, h), (i = (n = o(this, ue)).onSettled) == null || i.call(n, e.data, null, c, h)) : (e == null ? void 0 : e.type) === "error" && ((l = (a = o(this, ue)).onError) == null || l.call(a, e.error, c, h), (u = (f = o(this, ue)).onSettled) == null || u.call(
        f,
        void 0,
        e.error,
        c,
        h
      ));
    }
    this.listeners.forEach((c) => {
      c(o(this, ke));
    });
  });
}, us), Es = q.createContext(
  void 0
), Rs = (t) => {
  const e = q.useContext(Es);
  if (!e)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return e;
}, ri = ({
  client: t,
  children: e
}) => (q.useEffect(() => (t.mount(), () => {
  t.unmount();
}), [t]), /* @__PURE__ */ m(Es.Provider, { value: t, children: e })), Cs = q.createContext(!1), si = () => q.useContext(Cs);
Cs.Provider;
function ni() {
  let t = !1;
  return {
    clearReset: () => {
      t = !1;
    },
    reset: () => {
      t = !0;
    },
    isReset: () => t
  };
}
var ii = q.createContext(ni()), ai = () => q.useContext(ii);
function Ts(t, e) {
  return typeof t == "function" ? t(...e) : !!t;
}
function hr() {
}
var oi = (t, e) => {
  (t.suspense || t.throwOnError || t.experimental_prefetchInRender) && (e.isReset() || (t.retryOnMount = !1));
}, li = (t) => {
  q.useEffect(() => {
    t.clearReset();
  }, [t]);
}, ui = ({
  result: t,
  errorResetBoundary: e,
  throwOnError: r,
  query: s
}) => t.isError && !e.isReset() && !t.isFetching && s && Ts(r, [t.error, s]), ci = (t) => {
  const e = t.staleTime;
  t.suspense && (t.staleTime = typeof e == "function" ? (...r) => Math.max(e(...r), 1e3) : Math.max(e ?? 1e3, 1e3), typeof t.gcTime == "number" && (t.gcTime = Math.max(t.gcTime, 1e3)));
}, di = (t, e) => t.isLoading && t.isFetching && !e, hi = (t, e) => (t == null ? void 0 : t.suspense) && e.isPending, qr = (t, e, r) => e.fetchOptimistic(t).catch(() => {
  r.clearReset();
});
function fi(t, e, r) {
  var h, y, k, w, g;
  if (process.env.NODE_ENV !== "production" && (typeof t != "object" || Array.isArray(t)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const s = Rs(), n = si(), i = ai(), a = s.defaultQueryOptions(t);
  (y = (h = s.getDefaultOptions().queries) == null ? void 0 : h._experimental_beforeQuery) == null || y.call(
    h,
    a
  ), a._optimisticResults = n ? "isRestoring" : "optimistic", ci(a), oi(a, i), li(i);
  const l = !s.getQueryCache().get(a.queryHash), [f] = q.useState(
    () => new e(
      s,
      a
    )
  ), u = f.getOptimisticResult(a), c = !n && t.subscribed !== !1;
  if (q.useSyncExternalStore(
    q.useCallback(
      (p) => {
        const v = c ? f.subscribe(_.batchCalls(p)) : hr;
        return f.updateResult(), v;
      },
      [f, c]
    ),
    () => f.getCurrentResult(),
    () => f.getCurrentResult()
  ), q.useEffect(() => {
    f.setOptions(a, { listeners: !1 });
  }, [a, f]), hi(a, u))
    throw qr(a, f, i);
  if (ui({
    result: u,
    errorResetBoundary: i,
    throwOnError: a.throwOnError,
    query: s.getQueryCache().get(a.queryHash)
  }))
    throw u.error;
  if ((w = (k = s.getDefaultOptions().queries) == null ? void 0 : k._experimental_afterQuery) == null || w.call(
    k,
    a,
    u
  ), a.experimental_prefetchInRender && !xe && di(u, n)) {
    const p = l ? (
      // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
      qr(a, f, i)
    ) : (
      // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
      (g = s.getQueryCache().get(a.queryHash)) == null ? void 0 : g.promise
    );
    p == null || p.catch(hr).finally(() => {
      f.updateResult();
    });
  }
  return a.notifyOnChangeProps ? u : f.trackResult(u);
}
function mi(t, e) {
  return fi(t, Xn);
}
function at(t, e) {
  const r = Rs(), [s] = q.useState(
    () => new ti(
      r,
      t
    )
  );
  q.useEffect(() => {
    s.setOptions(t);
  }, [s, t]);
  const n = q.useSyncExternalStore(
    q.useCallback(
      (a) => s.subscribe(_.batchCalls(a)),
      [s]
    ),
    () => s.getCurrentResult(),
    () => s.getCurrentResult()
  ), i = q.useCallback(
    (a, l) => {
      s.mutate(a, l).catch(hr);
    },
    [s]
  );
  if (n.error && Ts(s.options.throwOnError, [n.error]))
    throw n.error;
  return { ...n, mutate: i, mutateAsync: n.mutate };
}
function pi({ email: t, setEmail: e, setLocation: r }) {
  var u;
  const [s, n] = W(""), i = at({ mutationFn: () => br(t, s) }), a = Fe(), l = () => {
    r("forgot-password");
  }, f = (c) => {
    c.key === "Enter" && i.mutate();
  };
  return /* @__PURE__ */ M(Ze, { children: [
    /* @__PURE__ */ m(et, { children: /* @__PURE__ */ M(tt, { children: [
      /* @__PURE__ */ m("div", { className: "h-12" }),
      /* @__PURE__ */ m(rt, {}),
      /* @__PURE__ */ m(st, { text: a.loginPage.description }),
      /* @__PURE__ */ m(
        Xe,
        {
          label: a.common.email,
          onChange: (c) => e(c.target.value),
          type: "email",
          id: "email",
          value: t,
          placeholder: a.common.emailPlaceholder,
          Icon: () => /* @__PURE__ */ m(Sr, { className: "w-4 h-4" }),
          isError: !!i.error
        }
      ),
      /* @__PURE__ */ m("div", { className: "h-5" }),
      /* @__PURE__ */ m(
        Yt,
        {
          label: a.common.password,
          placeholder: a.common.passwordPlaceholder,
          id: "password",
          value: s,
          isError: !!i.error,
          onChange: (c) => n(c.target.value),
          Icon: () => /* @__PURE__ */ m(ft, { className: "w-4 h-4" }),
          onKeyDown: f
        }
      ),
      /* @__PURE__ */ m("div", { className: "h-1" }),
      /* @__PURE__ */ M("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ m(Lt, { error: ((u = i.error) == null ? void 0 : u.message) ?? null }),
        /* @__PURE__ */ m(
          "button",
          {
            onClick: l,
            className: "text-xs font-medium text-black hover:underline",
            children: a.loginPage.forgotPassword
          }
        )
      ] }),
      /* @__PURE__ */ m("div", { className: "h-16" }),
      /* @__PURE__ */ m(Ae, { showLoading: i.isPending, onClick: () => i.mutate(), children: a.loginPage.login }),
      /* @__PURE__ */ m("div", { className: "h-12" })
    ] }) }),
    /* @__PURE__ */ m(nt, {})
  ] });
}
const gi = ({ email: t, setEmail: e, setLocation: r }) => {
  var i;
  const s = at({ mutationFn: Pn }), n = Fe();
  return /* @__PURE__ */ M(Ze, { children: [
    /* @__PURE__ */ m(et, { children: /* @__PURE__ */ M(tt, { children: [
      /* @__PURE__ */ m("div", { className: "h-12" }),
      /* @__PURE__ */ m(rt, {}),
      /* @__PURE__ */ m(st, { text: n.forgotPasswordPage.description }),
      /* @__PURE__ */ m("div", { className: "h-2" }),
      /* @__PURE__ */ m(
        Xe,
        {
          onChange: (a) => {
            e(a.target.value);
          },
          type: "email",
          id: "email",
          value: t,
          placeholder: n.common.emailPlaceholder,
          Icon: () => /* @__PURE__ */ m(Sr, { className: "w-4 h-4" }),
          label: n.common.email,
          isError: !!s.error
        }
      ),
      /* @__PURE__ */ m("div", { className: "h-2" }),
      /* @__PURE__ */ m(Lt, { error: ((i = s.error) == null ? void 0 : i.message) ?? null }),
      /* @__PURE__ */ M(
        "button",
        {
          onClick: () => r(null),
          className: "self-start text-xs font-medium text-black hover:underline li",
          children: [
            /* @__PURE__ */ m(fs, { className: "transform h-3 inline-block" }),
            n.common.login
          ]
        }
      ),
      /* @__PURE__ */ m("div", { className: "h-16" }),
      s.isSuccess ? /* @__PURE__ */ m("p", { className: "font-inter text-xs tracking-wide antialiased text-black font-semibold text-center px-6 py-3 rounded-smaller border border-dark-border", children: n.forgotPasswordPage.emailSentSuccess }) : /* @__PURE__ */ m(Ae, { showLoading: s.isPending, onClick: () => s.mutate({ email: t }), children: n.forgotPasswordPage.recoverPassword }),
      /* @__PURE__ */ m("div", { className: "h-12" })
    ] }) }),
    /* @__PURE__ */ m(nt, {})
  ] });
};
function Os(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: yi } = Object.prototype, { getPrototypeOf: Rr } = Object, Ut = /* @__PURE__ */ ((t) => (e) => {
  const r = yi.call(e);
  return t[r] || (t[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), te = (t) => (t = t.toLowerCase(), (e) => Ut(e) === t), _t = (t) => (e) => typeof e === t, { isArray: ot } = Array, pt = _t("undefined");
function wi(t) {
  return t !== null && !pt(t) && t.constructor !== null && !pt(t.constructor) && $(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const Ds = te("ArrayBuffer");
function bi(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && Ds(t.buffer), e;
}
const ki = _t("string"), $ = _t("function"), As = _t("number"), qt = (t) => t !== null && typeof t == "object", Si = (t) => t === !0 || t === !1, Ct = (t) => {
  if (Ut(t) !== "object")
    return !1;
  const e = Rr(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, vi = te("Date"), Pi = te("File"), Ei = te("Blob"), Ri = te("FileList"), Ci = (t) => qt(t) && $(t.pipe), Ti = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || $(t.append) && ((e = Ut(t)) === "formdata" || // detect form-data instance
  e === "object" && $(t.toString) && t.toString() === "[object FormData]"));
}, Oi = te("URLSearchParams"), [Di, Ai, Fi, xi] = ["ReadableStream", "Request", "Response", "Headers"].map(te), Ni = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function kt(t, e, { allOwnKeys: r = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let s, n;
  if (typeof t != "object" && (t = [t]), ot(t))
    for (s = 0, n = t.length; s < n; s++)
      e.call(null, t[s], s, t);
  else {
    const i = r ? Object.getOwnPropertyNames(t) : Object.keys(t), a = i.length;
    let l;
    for (s = 0; s < a; s++)
      l = i[s], e.call(null, t[l], l, t);
  }
}
function Fs(t, e) {
  e = e.toLowerCase();
  const r = Object.keys(t);
  let s = r.length, n;
  for (; s-- > 0; )
    if (n = r[s], e === n.toLowerCase())
      return n;
  return null;
}
const Se = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, xs = (t) => !pt(t) && t !== Se;
function fr() {
  const { caseless: t } = xs(this) && this || {}, e = {}, r = (s, n) => {
    const i = t && Fs(e, n) || n;
    Ct(e[i]) && Ct(s) ? e[i] = fr(e[i], s) : Ct(s) ? e[i] = fr({}, s) : ot(s) ? e[i] = s.slice() : e[i] = s;
  };
  for (let s = 0, n = arguments.length; s < n; s++)
    arguments[s] && kt(arguments[s], r);
  return e;
}
const Li = (t, e, r, { allOwnKeys: s } = {}) => (kt(e, (n, i) => {
  r && $(n) ? t[i] = Os(n, r) : t[i] = n;
}, { allOwnKeys: s }), t), Ii = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), Mi = (t, e, r, s) => {
  t.prototype = Object.create(e.prototype, s), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), r && Object.assign(t.prototype, r);
}, Ui = (t, e, r, s) => {
  let n, i, a;
  const l = {};
  if (e = e || {}, t == null) return e;
  do {
    for (n = Object.getOwnPropertyNames(t), i = n.length; i-- > 0; )
      a = n[i], (!s || s(a, t, e)) && !l[a] && (e[a] = t[a], l[a] = !0);
    t = r !== !1 && Rr(t);
  } while (t && (!r || r(t, e)) && t !== Object.prototype);
  return e;
}, _i = (t, e, r) => {
  t = String(t), (r === void 0 || r > t.length) && (r = t.length), r -= e.length;
  const s = t.indexOf(e, r);
  return s !== -1 && s === r;
}, qi = (t) => {
  if (!t) return null;
  if (ot(t)) return t;
  let e = t.length;
  if (!As(e)) return null;
  const r = new Array(e);
  for (; e-- > 0; )
    r[e] = t[e];
  return r;
}, ji = /* @__PURE__ */ ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && Rr(Uint8Array)), Bi = (t, e) => {
  const s = (t && t[Symbol.iterator]).call(t);
  let n;
  for (; (n = s.next()) && !n.done; ) {
    const i = n.value;
    e.call(t, i[0], i[1]);
  }
}, Hi = (t, e) => {
  let r;
  const s = [];
  for (; (r = t.exec(e)) !== null; )
    s.push(r);
  return s;
}, Qi = te("HTMLFormElement"), zi = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, s, n) {
    return s.toUpperCase() + n;
  }
), jr = (({ hasOwnProperty: t }) => (e, r) => t.call(e, r))(Object.prototype), Ki = te("RegExp"), Ns = (t, e) => {
  const r = Object.getOwnPropertyDescriptors(t), s = {};
  kt(r, (n, i) => {
    let a;
    (a = e(n, i, t)) !== !1 && (s[i] = a || n);
  }), Object.defineProperties(t, s);
}, Vi = (t) => {
  Ns(t, (e, r) => {
    if ($(t) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const s = t[r];
    if ($(s)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, Wi = (t, e) => {
  const r = {}, s = (n) => {
    n.forEach((i) => {
      r[i] = !0;
    });
  };
  return ot(t) ? s(t) : s(String(t).split(e)), r;
}, Gi = () => {
}, $i = (t, e) => t != null && Number.isFinite(t = +t) ? t : e, Kt = "abcdefghijklmnopqrstuvwxyz", Br = "0123456789", Ls = {
  DIGIT: Br,
  ALPHA: Kt,
  ALPHA_DIGIT: Kt + Kt.toUpperCase() + Br
}, Ji = (t = 16, e = Ls.ALPHA_DIGIT) => {
  let r = "";
  const { length: s } = e;
  for (; t--; )
    r += e[Math.random() * s | 0];
  return r;
};
function Yi(t) {
  return !!(t && $(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
const Xi = (t) => {
  const e = new Array(10), r = (s, n) => {
    if (qt(s)) {
      if (e.indexOf(s) >= 0)
        return;
      if (!("toJSON" in s)) {
        e[n] = s;
        const i = ot(s) ? [] : {};
        return kt(s, (a, l) => {
          const f = r(a, n + 1);
          !pt(f) && (i[l] = f);
        }), e[n] = void 0, i;
      }
    }
    return s;
  };
  return r(t, 0);
}, Zi = te("AsyncFunction"), ea = (t) => t && (qt(t) || $(t)) && $(t.then) && $(t.catch), Is = ((t, e) => t ? setImmediate : e ? ((r, s) => (Se.addEventListener("message", ({ source: n, data: i }) => {
  n === Se && i === r && s.length && s.shift()();
}, !1), (n) => {
  s.push(n), Se.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  $(Se.postMessage)
), ta = typeof queueMicrotask < "u" ? queueMicrotask.bind(Se) : typeof process < "u" && process.nextTick || Is, d = {
  isArray: ot,
  isArrayBuffer: Ds,
  isBuffer: wi,
  isFormData: Ti,
  isArrayBufferView: bi,
  isString: ki,
  isNumber: As,
  isBoolean: Si,
  isObject: qt,
  isPlainObject: Ct,
  isReadableStream: Di,
  isRequest: Ai,
  isResponse: Fi,
  isHeaders: xi,
  isUndefined: pt,
  isDate: vi,
  isFile: Pi,
  isBlob: Ei,
  isRegExp: Ki,
  isFunction: $,
  isStream: Ci,
  isURLSearchParams: Oi,
  isTypedArray: ji,
  isFileList: Ri,
  forEach: kt,
  merge: fr,
  extend: Li,
  trim: Ni,
  stripBOM: Ii,
  inherits: Mi,
  toFlatObject: Ui,
  kindOf: Ut,
  kindOfTest: te,
  endsWith: _i,
  toArray: qi,
  forEachEntry: Bi,
  matchAll: Hi,
  isHTMLForm: Qi,
  hasOwnProperty: jr,
  hasOwnProp: jr,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Ns,
  freezeMethods: Vi,
  toObjectSet: Wi,
  toCamelCase: zi,
  noop: Gi,
  toFiniteNumber: $i,
  findKey: Fs,
  global: Se,
  isContextDefined: xs,
  ALPHABET: Ls,
  generateString: Ji,
  isSpecCompliantForm: Yi,
  toJSONObject: Xi,
  isAsyncFn: Zi,
  isThenable: ea,
  setImmediate: Is,
  asap: ta
};
function C(t, e, r, s, n) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), r && (this.config = r), s && (this.request = s), n && (this.response = n, this.status = n.status ? n.status : null);
}
d.inherits(C, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: d.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Ms = C.prototype, Us = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  Us[t] = { value: t };
});
Object.defineProperties(C, Us);
Object.defineProperty(Ms, "isAxiosError", { value: !0 });
C.from = (t, e, r, s, n, i) => {
  const a = Object.create(Ms);
  return d.toFlatObject(t, a, function(f) {
    return f !== Error.prototype;
  }, (l) => l !== "isAxiosError"), C.call(a, t.message, e, r, s, n), a.cause = t, a.name = t.name, i && Object.assign(a, i), a;
};
const ra = null;
function mr(t) {
  return d.isPlainObject(t) || d.isArray(t);
}
function _s(t) {
  return d.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function Hr(t, e, r) {
  return t ? t.concat(e).map(function(n, i) {
    return n = _s(n), !r && i ? "[" + n + "]" : n;
  }).join(r ? "." : "") : e;
}
function sa(t) {
  return d.isArray(t) && !t.some(mr);
}
const na = d.toFlatObject(d, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function jt(t, e, r) {
  if (!d.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), r = d.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(g, p) {
    return !d.isUndefined(p[g]);
  });
  const s = r.metaTokens, n = r.visitor || c, i = r.dots, a = r.indexes, f = (r.Blob || typeof Blob < "u" && Blob) && d.isSpecCompliantForm(e);
  if (!d.isFunction(n))
    throw new TypeError("visitor must be a function");
  function u(w) {
    if (w === null) return "";
    if (d.isDate(w))
      return w.toISOString();
    if (!f && d.isBlob(w))
      throw new C("Blob is not supported. Use a Buffer instead.");
    return d.isArrayBuffer(w) || d.isTypedArray(w) ? f && typeof Blob == "function" ? new Blob([w]) : Buffer.from(w) : w;
  }
  function c(w, g, p) {
    let v = w;
    if (w && !p && typeof w == "object") {
      if (d.endsWith(g, "{}"))
        g = s ? g : g.slice(0, -2), w = JSON.stringify(w);
      else if (d.isArray(w) && sa(w) || (d.isFileList(w) || d.endsWith(g, "[]")) && (v = d.toArray(w)))
        return g = _s(g), v.forEach(function(P, F) {
          !(d.isUndefined(P) || P === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? Hr([g], F, i) : a === null ? g : g + "[]",
            u(P)
          );
        }), !1;
    }
    return mr(w) ? !0 : (e.append(Hr(p, g, i), u(w)), !1);
  }
  const h = [], y = Object.assign(na, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: mr
  });
  function k(w, g) {
    if (!d.isUndefined(w)) {
      if (h.indexOf(w) !== -1)
        throw Error("Circular reference detected in " + g.join("."));
      h.push(w), d.forEach(w, function(v, E) {
        (!(d.isUndefined(v) || v === null) && n.call(
          e,
          v,
          d.isString(E) ? E.trim() : E,
          g,
          y
        )) === !0 && k(v, g ? g.concat(E) : [E]);
      }), h.pop();
    }
  }
  if (!d.isObject(t))
    throw new TypeError("data must be an object");
  return k(t), e;
}
function Qr(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(s) {
    return e[s];
  });
}
function Cr(t, e) {
  this._pairs = [], t && jt(t, this, e);
}
const qs = Cr.prototype;
qs.append = function(e, r) {
  this._pairs.push([e, r]);
};
qs.toString = function(e) {
  const r = e ? function(s) {
    return e.call(this, s, Qr);
  } : Qr;
  return this._pairs.map(function(n) {
    return r(n[0]) + "=" + r(n[1]);
  }, "").join("&");
};
function ia(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function js(t, e, r) {
  if (!e)
    return t;
  const s = r && r.encode || ia;
  d.isFunction(r) && (r = {
    serialize: r
  });
  const n = r && r.serialize;
  let i;
  if (n ? i = n(e, r) : i = d.isURLSearchParams(e) ? e.toString() : new Cr(e, r).toString(s), i) {
    const a = t.indexOf("#");
    a !== -1 && (t = t.slice(0, a)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}
class zr {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, r, s) {
    return this.handlers.push({
      fulfilled: e,
      rejected: r,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    d.forEach(this.handlers, function(s) {
      s !== null && e(s);
    });
  }
}
const Bs = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, aa = typeof URLSearchParams < "u" ? URLSearchParams : Cr, oa = typeof FormData < "u" ? FormData : null, la = typeof Blob < "u" ? Blob : null, ua = {
  isBrowser: !0,
  classes: {
    URLSearchParams: aa,
    FormData: oa,
    Blob: la
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Tr = typeof window < "u" && typeof document < "u", pr = typeof navigator == "object" && navigator || void 0, ca = Tr && (!pr || ["ReactNative", "NativeScript", "NS"].indexOf(pr.product) < 0), da = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", ha = Tr && window.location.href || "http://localhost", fa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Tr,
  hasStandardBrowserEnv: ca,
  hasStandardBrowserWebWorkerEnv: da,
  navigator: pr,
  origin: ha
}, Symbol.toStringTag, { value: "Module" })), B = {
  ...fa,
  ...ua
};
function ma(t, e) {
  return jt(t, new B.classes.URLSearchParams(), Object.assign({
    visitor: function(r, s, n, i) {
      return B.isNode && d.isBuffer(r) ? (this.append(s, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function pa(t) {
  return d.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function ga(t) {
  const e = {}, r = Object.keys(t);
  let s;
  const n = r.length;
  let i;
  for (s = 0; s < n; s++)
    i = r[s], e[i] = t[i];
  return e;
}
function Hs(t) {
  function e(r, s, n, i) {
    let a = r[i++];
    if (a === "__proto__") return !0;
    const l = Number.isFinite(+a), f = i >= r.length;
    return a = !a && d.isArray(n) ? n.length : a, f ? (d.hasOwnProp(n, a) ? n[a] = [n[a], s] : n[a] = s, !l) : ((!n[a] || !d.isObject(n[a])) && (n[a] = []), e(r, s, n[a], i) && d.isArray(n[a]) && (n[a] = ga(n[a])), !l);
  }
  if (d.isFormData(t) && d.isFunction(t.entries)) {
    const r = {};
    return d.forEachEntry(t, (s, n) => {
      e(pa(s), n, r, 0);
    }), r;
  }
  return null;
}
function ya(t, e, r) {
  if (d.isString(t))
    try {
      return (e || JSON.parse)(t), d.trim(t);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (0, JSON.stringify)(t);
}
const St = {
  transitional: Bs,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, r) {
    const s = r.getContentType() || "", n = s.indexOf("application/json") > -1, i = d.isObject(e);
    if (i && d.isHTMLForm(e) && (e = new FormData(e)), d.isFormData(e))
      return n ? JSON.stringify(Hs(e)) : e;
    if (d.isArrayBuffer(e) || d.isBuffer(e) || d.isStream(e) || d.isFile(e) || d.isBlob(e) || d.isReadableStream(e))
      return e;
    if (d.isArrayBufferView(e))
      return e.buffer;
    if (d.isURLSearchParams(e))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let l;
    if (i) {
      if (s.indexOf("application/x-www-form-urlencoded") > -1)
        return ma(e, this.formSerializer).toString();
      if ((l = d.isFileList(e)) || s.indexOf("multipart/form-data") > -1) {
        const f = this.env && this.env.FormData;
        return jt(
          l ? { "files[]": e } : e,
          f && new f(),
          this.formSerializer
        );
      }
    }
    return i || n ? (r.setContentType("application/json", !1), ya(e)) : e;
  }],
  transformResponse: [function(e) {
    const r = this.transitional || St.transitional, s = r && r.forcedJSONParsing, n = this.responseType === "json";
    if (d.isResponse(e) || d.isReadableStream(e))
      return e;
    if (e && d.isString(e) && (s && !this.responseType || n)) {
      const a = !(r && r.silentJSONParsing) && n;
      try {
        return JSON.parse(e);
      } catch (l) {
        if (a)
          throw l.name === "SyntaxError" ? C.from(l, C.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: B.classes.FormData,
    Blob: B.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
d.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  St.headers[t] = {};
});
const wa = d.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), ba = (t) => {
  const e = {};
  let r, s, n;
  return t && t.split(`
`).forEach(function(a) {
    n = a.indexOf(":"), r = a.substring(0, n).trim().toLowerCase(), s = a.substring(n + 1).trim(), !(!r || e[r] && wa[r]) && (r === "set-cookie" ? e[r] ? e[r].push(s) : e[r] = [s] : e[r] = e[r] ? e[r] + ", " + s : s);
  }), e;
}, Kr = Symbol("internals");
function ut(t) {
  return t && String(t).trim().toLowerCase();
}
function Tt(t) {
  return t === !1 || t == null ? t : d.isArray(t) ? t.map(Tt) : String(t);
}
function ka(t) {
  const e = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = r.exec(t); )
    e[s[1]] = s[2];
  return e;
}
const Sa = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function Vt(t, e, r, s, n) {
  if (d.isFunction(s))
    return s.call(this, e, r);
  if (n && (e = r), !!d.isString(e)) {
    if (d.isString(s))
      return e.indexOf(s) !== -1;
    if (d.isRegExp(s))
      return s.test(e);
  }
}
function va(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, r, s) => r.toUpperCase() + s);
}
function Pa(t, e) {
  const r = d.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((s) => {
    Object.defineProperty(t, s + r, {
      value: function(n, i, a) {
        return this[s].call(this, e, n, i, a);
      },
      configurable: !0
    });
  });
}
class G {
  constructor(e) {
    e && this.set(e);
  }
  set(e, r, s) {
    const n = this;
    function i(l, f, u) {
      const c = ut(f);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const h = d.findKey(n, c);
      (!h || n[h] === void 0 || u === !0 || u === void 0 && n[h] !== !1) && (n[h || f] = Tt(l));
    }
    const a = (l, f) => d.forEach(l, (u, c) => i(u, c, f));
    if (d.isPlainObject(e) || e instanceof this.constructor)
      a(e, r);
    else if (d.isString(e) && (e = e.trim()) && !Sa(e))
      a(ba(e), r);
    else if (d.isHeaders(e))
      for (const [l, f] of e.entries())
        i(f, l, s);
    else
      e != null && i(r, e, s);
    return this;
  }
  get(e, r) {
    if (e = ut(e), e) {
      const s = d.findKey(this, e);
      if (s) {
        const n = this[s];
        if (!r)
          return n;
        if (r === !0)
          return ka(n);
        if (d.isFunction(r))
          return r.call(this, n, s);
        if (d.isRegExp(r))
          return r.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, r) {
    if (e = ut(e), e) {
      const s = d.findKey(this, e);
      return !!(s && this[s] !== void 0 && (!r || Vt(this, this[s], s, r)));
    }
    return !1;
  }
  delete(e, r) {
    const s = this;
    let n = !1;
    function i(a) {
      if (a = ut(a), a) {
        const l = d.findKey(s, a);
        l && (!r || Vt(s, s[l], l, r)) && (delete s[l], n = !0);
      }
    }
    return d.isArray(e) ? e.forEach(i) : i(e), n;
  }
  clear(e) {
    const r = Object.keys(this);
    let s = r.length, n = !1;
    for (; s--; ) {
      const i = r[s];
      (!e || Vt(this, this[i], i, e, !0)) && (delete this[i], n = !0);
    }
    return n;
  }
  normalize(e) {
    const r = this, s = {};
    return d.forEach(this, (n, i) => {
      const a = d.findKey(s, i);
      if (a) {
        r[a] = Tt(n), delete r[i];
        return;
      }
      const l = e ? va(i) : String(i).trim();
      l !== i && delete r[i], r[l] = Tt(n), s[l] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const r = /* @__PURE__ */ Object.create(null);
    return d.forEach(this, (s, n) => {
      s != null && s !== !1 && (r[n] = e && d.isArray(s) ? s.join(", ") : s);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, r]) => e + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...r) {
    const s = new this(e);
    return r.forEach((n) => s.set(n)), s;
  }
  static accessor(e) {
    const s = (this[Kr] = this[Kr] = {
      accessors: {}
    }).accessors, n = this.prototype;
    function i(a) {
      const l = ut(a);
      s[l] || (Pa(n, a), s[l] = !0);
    }
    return d.isArray(e) ? e.forEach(i) : i(e), this;
  }
}
G.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
d.reduceDescriptors(G.prototype, ({ value: t }, e) => {
  let r = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(s) {
      this[r] = s;
    }
  };
});
d.freezeMethods(G);
function Wt(t, e) {
  const r = this || St, s = e || r, n = G.from(s.headers);
  let i = s.data;
  return d.forEach(t, function(l) {
    i = l.call(r, i, n.normalize(), e ? e.status : void 0);
  }), n.normalize(), i;
}
function Qs(t) {
  return !!(t && t.__CANCEL__);
}
function lt(t, e, r) {
  C.call(this, t ?? "canceled", C.ERR_CANCELED, e, r), this.name = "CanceledError";
}
d.inherits(lt, C, {
  __CANCEL__: !0
});
function zs(t, e, r) {
  const s = r.config.validateStatus;
  !r.status || !s || s(r.status) ? t(r) : e(new C(
    "Request failed with status code " + r.status,
    [C.ERR_BAD_REQUEST, C.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function Ea(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function Ra(t, e) {
  t = t || 10;
  const r = new Array(t), s = new Array(t);
  let n = 0, i = 0, a;
  return e = e !== void 0 ? e : 1e3, function(f) {
    const u = Date.now(), c = s[i];
    a || (a = u), r[n] = f, s[n] = u;
    let h = i, y = 0;
    for (; h !== n; )
      y += r[h++], h = h % t;
    if (n = (n + 1) % t, n === i && (i = (i + 1) % t), u - a < e)
      return;
    const k = c && u - c;
    return k ? Math.round(y * 1e3 / k) : void 0;
  };
}
function Ca(t, e) {
  let r = 0, s = 1e3 / e, n, i;
  const a = (u, c = Date.now()) => {
    r = c, n = null, i && (clearTimeout(i), i = null), t.apply(null, u);
  };
  return [(...u) => {
    const c = Date.now(), h = c - r;
    h >= s ? a(u, c) : (n = u, i || (i = setTimeout(() => {
      i = null, a(n);
    }, s - h)));
  }, () => n && a(n)];
}
const xt = (t, e, r = 3) => {
  let s = 0;
  const n = Ra(50, 250);
  return Ca((i) => {
    const a = i.loaded, l = i.lengthComputable ? i.total : void 0, f = a - s, u = n(f), c = a <= l;
    s = a;
    const h = {
      loaded: a,
      total: l,
      progress: l ? a / l : void 0,
      bytes: f,
      rate: u || void 0,
      estimated: u && l && c ? (l - a) / u : void 0,
      event: i,
      lengthComputable: l != null,
      [e ? "download" : "upload"]: !0
    };
    t(h);
  }, r);
}, Vr = (t, e) => {
  const r = t != null;
  return [(s) => e[0]({
    lengthComputable: r,
    total: t,
    loaded: s
  }), e[1]];
}, Wr = (t) => (...e) => d.asap(() => t(...e)), Ta = B.hasStandardBrowserEnv ? /* @__PURE__ */ ((t, e) => (r) => (r = new URL(r, B.origin), t.protocol === r.protocol && t.host === r.host && (e || t.port === r.port)))(
  new URL(B.origin),
  B.navigator && /(msie|trident)/i.test(B.navigator.userAgent)
) : () => !0, Oa = B.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, r, s, n, i) {
      const a = [t + "=" + encodeURIComponent(e)];
      d.isNumber(r) && a.push("expires=" + new Date(r).toGMTString()), d.isString(s) && a.push("path=" + s), d.isString(n) && a.push("domain=" + n), i === !0 && a.push("secure"), document.cookie = a.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Da(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function Aa(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function Ks(t, e) {
  return t && !Da(e) ? Aa(t, e) : e;
}
const Gr = (t) => t instanceof G ? { ...t } : t;
function Le(t, e) {
  e = e || {};
  const r = {};
  function s(u, c, h, y) {
    return d.isPlainObject(u) && d.isPlainObject(c) ? d.merge.call({ caseless: y }, u, c) : d.isPlainObject(c) ? d.merge({}, c) : d.isArray(c) ? c.slice() : c;
  }
  function n(u, c, h, y) {
    if (d.isUndefined(c)) {
      if (!d.isUndefined(u))
        return s(void 0, u, h, y);
    } else return s(u, c, h, y);
  }
  function i(u, c) {
    if (!d.isUndefined(c))
      return s(void 0, c);
  }
  function a(u, c) {
    if (d.isUndefined(c)) {
      if (!d.isUndefined(u))
        return s(void 0, u);
    } else return s(void 0, c);
  }
  function l(u, c, h) {
    if (h in e)
      return s(u, c);
    if (h in t)
      return s(void 0, u);
  }
  const f = {
    url: i,
    method: i,
    data: i,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: l,
    headers: (u, c, h) => n(Gr(u), Gr(c), h, !0)
  };
  return d.forEach(Object.keys(Object.assign({}, t, e)), function(c) {
    const h = f[c] || n, y = h(t[c], e[c], c);
    d.isUndefined(y) && h !== l || (r[c] = y);
  }), r;
}
const Vs = (t) => {
  const e = Le({}, t);
  let { data: r, withXSRFToken: s, xsrfHeaderName: n, xsrfCookieName: i, headers: a, auth: l } = e;
  e.headers = a = G.from(a), e.url = js(Ks(e.baseURL, e.url), t.params, t.paramsSerializer), l && a.set(
    "Authorization",
    "Basic " + btoa((l.username || "") + ":" + (l.password ? unescape(encodeURIComponent(l.password)) : ""))
  );
  let f;
  if (d.isFormData(r)) {
    if (B.hasStandardBrowserEnv || B.hasStandardBrowserWebWorkerEnv)
      a.setContentType(void 0);
    else if ((f = a.getContentType()) !== !1) {
      const [u, ...c] = f ? f.split(";").map((h) => h.trim()).filter(Boolean) : [];
      a.setContentType([u || "multipart/form-data", ...c].join("; "));
    }
  }
  if (B.hasStandardBrowserEnv && (s && d.isFunction(s) && (s = s(e)), s || s !== !1 && Ta(e.url))) {
    const u = n && i && Oa.read(i);
    u && a.set(n, u);
  }
  return e;
}, Fa = typeof XMLHttpRequest < "u", xa = Fa && function(t) {
  return new Promise(function(r, s) {
    const n = Vs(t);
    let i = n.data;
    const a = G.from(n.headers).normalize();
    let { responseType: l, onUploadProgress: f, onDownloadProgress: u } = n, c, h, y, k, w;
    function g() {
      k && k(), w && w(), n.cancelToken && n.cancelToken.unsubscribe(c), n.signal && n.signal.removeEventListener("abort", c);
    }
    let p = new XMLHttpRequest();
    p.open(n.method.toUpperCase(), n.url, !0), p.timeout = n.timeout;
    function v() {
      if (!p)
        return;
      const P = G.from(
        "getAllResponseHeaders" in p && p.getAllResponseHeaders()
      ), A = {
        data: !l || l === "text" || l === "json" ? p.responseText : p.response,
        status: p.status,
        statusText: p.statusText,
        headers: P,
        config: t,
        request: p
      };
      zs(function(D) {
        r(D), g();
      }, function(D) {
        s(D), g();
      }, A), p = null;
    }
    "onloadend" in p ? p.onloadend = v : p.onreadystatechange = function() {
      !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(v);
    }, p.onabort = function() {
      p && (s(new C("Request aborted", C.ECONNABORTED, t, p)), p = null);
    }, p.onerror = function() {
      s(new C("Network Error", C.ERR_NETWORK, t, p)), p = null;
    }, p.ontimeout = function() {
      let F = n.timeout ? "timeout of " + n.timeout + "ms exceeded" : "timeout exceeded";
      const A = n.transitional || Bs;
      n.timeoutErrorMessage && (F = n.timeoutErrorMessage), s(new C(
        F,
        A.clarifyTimeoutError ? C.ETIMEDOUT : C.ECONNABORTED,
        t,
        p
      )), p = null;
    }, i === void 0 && a.setContentType(null), "setRequestHeader" in p && d.forEach(a.toJSON(), function(F, A) {
      p.setRequestHeader(A, F);
    }), d.isUndefined(n.withCredentials) || (p.withCredentials = !!n.withCredentials), l && l !== "json" && (p.responseType = n.responseType), u && ([y, w] = xt(u, !0), p.addEventListener("progress", y)), f && p.upload && ([h, k] = xt(f), p.upload.addEventListener("progress", h), p.upload.addEventListener("loadend", k)), (n.cancelToken || n.signal) && (c = (P) => {
      p && (s(!P || P.type ? new lt(null, t, p) : P), p.abort(), p = null);
    }, n.cancelToken && n.cancelToken.subscribe(c), n.signal && (n.signal.aborted ? c() : n.signal.addEventListener("abort", c)));
    const E = Ea(n.url);
    if (E && B.protocols.indexOf(E) === -1) {
      s(new C("Unsupported protocol " + E + ":", C.ERR_BAD_REQUEST, t));
      return;
    }
    p.send(i || null);
  });
}, Na = (t, e) => {
  const { length: r } = t = t ? t.filter(Boolean) : [];
  if (e || r) {
    let s = new AbortController(), n;
    const i = function(u) {
      if (!n) {
        n = !0, l();
        const c = u instanceof Error ? u : this.reason;
        s.abort(c instanceof C ? c : new lt(c instanceof Error ? c.message : c));
      }
    };
    let a = e && setTimeout(() => {
      a = null, i(new C(`timeout ${e} of ms exceeded`, C.ETIMEDOUT));
    }, e);
    const l = () => {
      t && (a && clearTimeout(a), a = null, t.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(i) : u.removeEventListener("abort", i);
      }), t = null);
    };
    t.forEach((u) => u.addEventListener("abort", i));
    const { signal: f } = s;
    return f.unsubscribe = () => d.asap(l), f;
  }
}, La = function* (t, e) {
  let r = t.byteLength;
  if (r < e) {
    yield t;
    return;
  }
  let s = 0, n;
  for (; s < r; )
    n = s + e, yield t.slice(s, n), s = n;
}, Ia = async function* (t, e) {
  for await (const r of Ma(t))
    yield* La(r, e);
}, Ma = async function* (t) {
  if (t[Symbol.asyncIterator]) {
    yield* t;
    return;
  }
  const e = t.getReader();
  try {
    for (; ; ) {
      const { done: r, value: s } = await e.read();
      if (r)
        break;
      yield s;
    }
  } finally {
    await e.cancel();
  }
}, $r = (t, e, r, s) => {
  const n = Ia(t, e);
  let i = 0, a, l = (f) => {
    a || (a = !0, s && s(f));
  };
  return new ReadableStream({
    async pull(f) {
      try {
        const { done: u, value: c } = await n.next();
        if (u) {
          l(), f.close();
          return;
        }
        let h = c.byteLength;
        if (r) {
          let y = i += h;
          r(y);
        }
        f.enqueue(new Uint8Array(c));
      } catch (u) {
        throw l(u), u;
      }
    },
    cancel(f) {
      return l(f), n.return();
    }
  }, {
    highWaterMark: 2
  });
}, Bt = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Ws = Bt && typeof ReadableStream == "function", Ua = Bt && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((t) => (e) => t.encode(e))(new TextEncoder()) : async (t) => new Uint8Array(await new Response(t).arrayBuffer())), Gs = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, _a = Ws && Gs(() => {
  let t = !1;
  const e = new Request(B.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type");
  return t && !e;
}), Jr = 64 * 1024, gr = Ws && Gs(() => d.isReadableStream(new Response("").body)), Nt = {
  stream: gr && ((t) => t.body)
};
Bt && ((t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !Nt[e] && (Nt[e] = d.isFunction(t[e]) ? (r) => r[e]() : (r, s) => {
      throw new C(`Response type '${e}' is not supported`, C.ERR_NOT_SUPPORT, s);
    });
  });
})(new Response());
const qa = async (t) => {
  if (t == null)
    return 0;
  if (d.isBlob(t))
    return t.size;
  if (d.isSpecCompliantForm(t))
    return (await new Request(B.origin, {
      method: "POST",
      body: t
    }).arrayBuffer()).byteLength;
  if (d.isArrayBufferView(t) || d.isArrayBuffer(t))
    return t.byteLength;
  if (d.isURLSearchParams(t) && (t = t + ""), d.isString(t))
    return (await Ua(t)).byteLength;
}, ja = async (t, e) => {
  const r = d.toFiniteNumber(t.getContentLength());
  return r ?? qa(e);
}, Ba = Bt && (async (t) => {
  let {
    url: e,
    method: r,
    data: s,
    signal: n,
    cancelToken: i,
    timeout: a,
    onDownloadProgress: l,
    onUploadProgress: f,
    responseType: u,
    headers: c,
    withCredentials: h = "same-origin",
    fetchOptions: y
  } = Vs(t);
  u = u ? (u + "").toLowerCase() : "text";
  let k = Na([n, i && i.toAbortSignal()], a), w;
  const g = k && k.unsubscribe && (() => {
    k.unsubscribe();
  });
  let p;
  try {
    if (f && _a && r !== "get" && r !== "head" && (p = await ja(c, s)) !== 0) {
      let A = new Request(e, {
        method: "POST",
        body: s,
        duplex: "half"
      }), L;
      if (d.isFormData(s) && (L = A.headers.get("content-type")) && c.setContentType(L), A.body) {
        const [D, N] = Vr(
          p,
          xt(Wr(f))
        );
        s = $r(A.body, Jr, D, N);
      }
    }
    d.isString(h) || (h = h ? "include" : "omit");
    const v = "credentials" in Request.prototype;
    w = new Request(e, {
      ...y,
      signal: k,
      method: r.toUpperCase(),
      headers: c.normalize().toJSON(),
      body: s,
      duplex: "half",
      credentials: v ? h : void 0
    });
    let E = await fetch(w);
    const P = gr && (u === "stream" || u === "response");
    if (gr && (l || P && g)) {
      const A = {};
      ["status", "statusText", "headers"].forEach((R) => {
        A[R] = E[R];
      });
      const L = d.toFiniteNumber(E.headers.get("content-length")), [D, N] = l && Vr(
        L,
        xt(Wr(l), !0)
      ) || [];
      E = new Response(
        $r(E.body, Jr, D, () => {
          N && N(), g && g();
        }),
        A
      );
    }
    u = u || "text";
    let F = await Nt[d.findKey(Nt, u) || "text"](E, t);
    return !P && g && g(), await new Promise((A, L) => {
      zs(A, L, {
        data: F,
        headers: G.from(E.headers),
        status: E.status,
        statusText: E.statusText,
        config: t,
        request: w
      });
    });
  } catch (v) {
    throw g && g(), v && v.name === "TypeError" && /fetch/i.test(v.message) ? Object.assign(
      new C("Network Error", C.ERR_NETWORK, t, w),
      {
        cause: v.cause || v
      }
    ) : C.from(v, v && v.code, t, w);
  }
}), yr = {
  http: ra,
  xhr: xa,
  fetch: Ba
};
d.forEach(yr, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const Yr = (t) => `- ${t}`, Ha = (t) => d.isFunction(t) || t === null || t === !1, $s = {
  getAdapter: (t) => {
    t = d.isArray(t) ? t : [t];
    const { length: e } = t;
    let r, s;
    const n = {};
    for (let i = 0; i < e; i++) {
      r = t[i];
      let a;
      if (s = r, !Ha(r) && (s = yr[(a = String(r)).toLowerCase()], s === void 0))
        throw new C(`Unknown adapter '${a}'`);
      if (s)
        break;
      n[a || "#" + i] = s;
    }
    if (!s) {
      const i = Object.entries(n).map(
        ([l, f]) => `adapter ${l} ` + (f === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = e ? i.length > 1 ? `since :
` + i.map(Yr).join(`
`) : " " + Yr(i[0]) : "as no adapter specified";
      throw new C(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return s;
  },
  adapters: yr
};
function Gt(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new lt(null, t);
}
function Xr(t) {
  return Gt(t), t.headers = G.from(t.headers), t.data = Wt.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), $s.getAdapter(t.adapter || St.adapter)(t).then(function(s) {
    return Gt(t), s.data = Wt.call(
      t,
      t.transformResponse,
      s
    ), s.headers = G.from(s.headers), s;
  }, function(s) {
    return Qs(s) || (Gt(t), s && s.response && (s.response.data = Wt.call(
      t,
      t.transformResponse,
      s.response
    ), s.response.headers = G.from(s.response.headers))), Promise.reject(s);
  });
}
const Js = "1.7.9", Ht = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  Ht[t] = function(s) {
    return typeof s === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const Zr = {};
Ht.transitional = function(e, r, s) {
  function n(i, a) {
    return "[Axios v" + Js + "] Transitional option '" + i + "'" + a + (s ? ". " + s : "");
  }
  return (i, a, l) => {
    if (e === !1)
      throw new C(
        n(a, " has been removed" + (r ? " in " + r : "")),
        C.ERR_DEPRECATED
      );
    return r && !Zr[a] && (Zr[a] = !0, console.warn(
      n(
        a,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(i, a, l) : !0;
  };
};
Ht.spelling = function(e) {
  return (r, s) => (console.warn(`${s} is likely a misspelling of ${e}`), !0);
};
function Qa(t, e, r) {
  if (typeof t != "object")
    throw new C("options must be an object", C.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(t);
  let n = s.length;
  for (; n-- > 0; ) {
    const i = s[n], a = e[i];
    if (a) {
      const l = t[i], f = l === void 0 || a(l, i, t);
      if (f !== !0)
        throw new C("option " + i + " must be " + f, C.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new C("Unknown option " + i, C.ERR_BAD_OPTION);
  }
}
const Ot = {
  assertOptions: Qa,
  validators: Ht
}, re = Ot.validators;
class De {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new zr(),
      response: new zr()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, r) {
    try {
      return await this._request(e, r);
    } catch (s) {
      if (s instanceof Error) {
        let n = {};
        Error.captureStackTrace ? Error.captureStackTrace(n) : n = new Error();
        const i = n.stack ? n.stack.replace(/^.+\n/, "") : "";
        try {
          s.stack ? i && !String(s.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (s.stack += `
` + i) : s.stack = i;
        } catch {
        }
      }
      throw s;
    }
  }
  _request(e, r) {
    typeof e == "string" ? (r = r || {}, r.url = e) : r = e || {}, r = Le(this.defaults, r);
    const { transitional: s, paramsSerializer: n, headers: i } = r;
    s !== void 0 && Ot.assertOptions(s, {
      silentJSONParsing: re.transitional(re.boolean),
      forcedJSONParsing: re.transitional(re.boolean),
      clarifyTimeoutError: re.transitional(re.boolean)
    }, !1), n != null && (d.isFunction(n) ? r.paramsSerializer = {
      serialize: n
    } : Ot.assertOptions(n, {
      encode: re.function,
      serialize: re.function
    }, !0)), Ot.assertOptions(r, {
      baseUrl: re.spelling("baseURL"),
      withXsrfToken: re.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let a = i && d.merge(
      i.common,
      i[r.method]
    );
    i && d.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (w) => {
        delete i[w];
      }
    ), r.headers = G.concat(a, i);
    const l = [];
    let f = !0;
    this.interceptors.request.forEach(function(g) {
      typeof g.runWhen == "function" && g.runWhen(r) === !1 || (f = f && g.synchronous, l.unshift(g.fulfilled, g.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(g) {
      u.push(g.fulfilled, g.rejected);
    });
    let c, h = 0, y;
    if (!f) {
      const w = [Xr.bind(this), void 0];
      for (w.unshift.apply(w, l), w.push.apply(w, u), y = w.length, c = Promise.resolve(r); h < y; )
        c = c.then(w[h++], w[h++]);
      return c;
    }
    y = l.length;
    let k = r;
    for (h = 0; h < y; ) {
      const w = l[h++], g = l[h++];
      try {
        k = w(k);
      } catch (p) {
        g.call(this, p);
        break;
      }
    }
    try {
      c = Xr.call(this, k);
    } catch (w) {
      return Promise.reject(w);
    }
    for (h = 0, y = u.length; h < y; )
      c = c.then(u[h++], u[h++]);
    return c;
  }
  getUri(e) {
    e = Le(this.defaults, e);
    const r = Ks(e.baseURL, e.url);
    return js(r, e.params, e.paramsSerializer);
  }
}
d.forEach(["delete", "get", "head", "options"], function(e) {
  De.prototype[e] = function(r, s) {
    return this.request(Le(s || {}, {
      method: e,
      url: r,
      data: (s || {}).data
    }));
  };
});
d.forEach(["post", "put", "patch"], function(e) {
  function r(s) {
    return function(i, a, l) {
      return this.request(Le(l || {}, {
        method: e,
        headers: s ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: a
      }));
    };
  }
  De.prototype[e] = r(), De.prototype[e + "Form"] = r(!0);
});
class Or {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(i) {
      r = i;
    });
    const s = this;
    this.promise.then((n) => {
      if (!s._listeners) return;
      let i = s._listeners.length;
      for (; i-- > 0; )
        s._listeners[i](n);
      s._listeners = null;
    }), this.promise.then = (n) => {
      let i;
      const a = new Promise((l) => {
        s.subscribe(l), i = l;
      }).then(n);
      return a.cancel = function() {
        s.unsubscribe(i);
      }, a;
    }, e(function(i, a, l) {
      s.reason || (s.reason = new lt(i, a, l), r(s.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(e);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), r = (s) => {
      e.abort(s);
    };
    return this.subscribe(r), e.signal.unsubscribe = () => this.unsubscribe(r), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new Or(function(n) {
        e = n;
      }),
      cancel: e
    };
  }
}
function za(t) {
  return function(r) {
    return t.apply(null, r);
  };
}
function Ka(t) {
  return d.isObject(t) && t.isAxiosError === !0;
}
const wr = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(wr).forEach(([t, e]) => {
  wr[e] = t;
});
function Ys(t) {
  const e = new De(t), r = Os(De.prototype.request, e);
  return d.extend(r, De.prototype, e, { allOwnKeys: !0 }), d.extend(r, e, null, { allOwnKeys: !0 }), r.create = function(n) {
    return Ys(Le(t, n));
  }, r;
}
const U = Ys(St);
U.Axios = De;
U.CanceledError = lt;
U.CancelToken = Or;
U.isCancel = Qs;
U.VERSION = Js;
U.toFormData = jt;
U.AxiosError = C;
U.Cancel = U.CanceledError;
U.all = function(e) {
  return Promise.all(e);
};
U.spread = za;
U.isAxiosError = Ka;
U.mergeConfig = Le;
U.AxiosHeaders = G;
U.formToJSON = (t) => Hs(d.isHTMLForm(t) ? new FormData(t) : t);
U.getAdapter = $s.getAdapter;
U.HttpStatusCode = wr;
U.default = U;
const Dr = U.create({
  baseURL: "http://localhost:3000/api/express/auth"
});
async function Va(t) {
  const e = await kr(), r = {
    verification_token: t
  };
  await Dr.post("/verify-email", r, {
    headers: {
      Authorization: `Bearer ${e}`
    }
  });
}
async function Wa() {
  const t = await kr(), e = {
    verification_link_base_url: "https://qura.law"
  };
  await Dr.post("/send-email-verification-email", e, {
    headers: {
      Authorization: `Bearer ${t}`
    }
  });
}
async function Ga(t) {
  const e = await Dr.post("/signup", t).then((s) => s.data).catch((s) => {
    var n;
    return (n = s.response) == null ? void 0 : n.data;
  }), r = pn.parse(e);
  if (!r.ok)
    throw r.error;
  await br(t.email, t.password);
}
function $a({ token: t, setLocation: e, email: r, setEmail: s, db: n }) {
  const [i, a] = W(""), [l, f] = W(""), [u, c] = W(""), h = at({ mutationFn: Ga }), y = Fe(), k = {
    "internal-server-error": y.errors.unknown,
    "email-not-verified": y.errors.emailNotConfirmed,
    "username-too-short": y.errors.nameTooShort,
    "password-too-short": y.errors.passwordTooShort,
    "email-invalid": y.errors.invalidEmail,
    "email-occupied": y.errors.emailAlreadyUsed,
    "signup-token-invalid": y.errors.invalidSignupToken,
    "signup-token-exhausted": y.errors.invalidSignupToken,
    "signup-token-expired": y.errors.invalidSignupToken,
    "email-domain-mismatch": y.errors.invalidSignupToken
  }, w = mi({
    queryKey: ["signup-company", t],
    queryFn: () => vn(n, t ?? "")
  }), [g, p] = W(!1), [v, E] = W(!1), [P, F] = W(!1), [A, L] = W([]), D = Fe(), N = () => {
    const R = [];
    i.length === 0 ? (R.push(y.errors.nameRequired), p(!0)) : i.length <= 2 ? (R.push(y.errors.nameTooShort), p(!0)) : p(!1), r.length === 0 ? (R.push(y.errors.emailRequired), E(!0)) : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(r) ? E(!1) : (R.push(y.errors.emailInvalid), E(!0)), l.length < 8 ? (R.push(y.errors.passwordTooShort), F(!0)) : l !== u ? (R.push(y.errors.passwordMismatch), F(!0)) : F(!1), L(R), !(R.length > 0) && t && h.mutate({ username: i, email: r, password: l, token: t });
  };
  return /* @__PURE__ */ M(Ze, { children: [
    /* @__PURE__ */ M(et, { children: [
      w.data ? /* @__PURE__ */ m("div", { className: "flex flex-col items-center justify-center mt-8 mb-6", children: /* @__PURE__ */ m("p", { className: "rounded-[39px] text-qura-neutral-jet text-xs text-center bg-qura-neutral-ghost px-2 py-1 ", children: w.data.name }) }) : /* @__PURE__ */ m("div", { className: "h-12" }),
      /* @__PURE__ */ m(rt, {}),
      /* @__PURE__ */ M(tt, { children: [
        /* @__PURE__ */ m(st, { text: D.signupPage.description }),
        /* @__PURE__ */ m(
          Xe,
          {
            onChange: (R) => a(R.target.value),
            type: "text",
            id: "name",
            value: i || "",
            placeholder: D.signupPage.namePlaceholder,
            Icon: () => /* @__PURE__ */ m(xn, {}),
            label: D.common.name,
            isError: g
          }
        ),
        /* @__PURE__ */ m("div", { className: "h-5" }),
        /* @__PURE__ */ m(
          Xe,
          {
            onChange: (R) => s(R.target.value),
            type: "email",
            id: "email",
            value: r,
            placeholder: D.common.emailPlaceholder,
            Icon: () => /* @__PURE__ */ m(Sr, {}),
            label: D.common.email,
            isError: v
          }
        ),
        /* @__PURE__ */ m("div", { className: "h-5" }),
        /* @__PURE__ */ m(
          Yt,
          {
            label: D.common.password,
            placeholder: D.common.passwordPlaceholder,
            id: "password",
            value: l,
            isError: P,
            onChange: (R) => f(R.target.value),
            Icon: () => /* @__PURE__ */ m(ft, {})
          }
        ),
        /* @__PURE__ */ m("div", { className: "h-5" }),
        /* @__PURE__ */ m(
          Yt,
          {
            label: D.common.confirmPassword,
            placeholder: D.signupPage.confirmPasswordPlaceholder,
            id: "confirm-password",
            value: u,
            isError: P,
            onChange: (R) => c(R.target.value),
            Icon: () => /* @__PURE__ */ m(ft, {})
          }
        ),
        /* @__PURE__ */ m("div", { className: "flex pt-2 min-h-16 pb-10", children: /* @__PURE__ */ m(Lt, { error: A.length > 0 ? A.join(`
`) : h.error ? k[h.error.code] : null }) }),
        /* @__PURE__ */ m(Ae, { showLoading: h.isPending, onClick: N, children: D.signupPage.signup }),
        /* @__PURE__ */ m("div", { className: "h-5" }),
        /* @__PURE__ */ M("div", { className: "font-inter text-xs font-medium flex items-center justify-center", children: [
          /* @__PURE__ */ m("p", { className: "text-qura-neutral-balanced pr-1", children: "Already have an account?" }),
          /* @__PURE__ */ m("button", { className: "hover:underline", onClick: () => e(null), children: "Log in." })
        ] }),
        /* @__PURE__ */ m("div", { className: "h-7" })
      ] })
    ] }),
    /* @__PURE__ */ m(nt, {})
  ] });
}
const Ja = ({ setLocation: t, oobCode: e }) => {
  const r = at({ mutationFn: En }), [s, n] = W(null), [i, a] = W(""), [l, f] = W(""), u = Fe(), c = () => {
    if (!i || !l) {
      n("Please fill in all fields.");
      return;
    }
    if (i !== l) {
      n("Passwords do not match.");
      return;
    }
    if (!e) {
      n("Invalid reset password code.");
      return;
    }
    r.mutate({ code: e, password: i });
  }, h = () => {
    t(null);
  };
  return /* @__PURE__ */ M(Ze, { children: [
    /* @__PURE__ */ m(et, { children: /* @__PURE__ */ M(tt, { children: [
      /* @__PURE__ */ m("div", { className: "h-12" }),
      /* @__PURE__ */ m(rt, {}),
      /* @__PURE__ */ m(st, { text: u.resetPasswordPage.resetPassword }),
      r.isSuccess ? /* @__PURE__ */ M($t, { children: [
        /* @__PURE__ */ m("p", { className: "text-black text-sm tracking-wide mb-5 mt-2 text-center", children: u.resetPasswordPage.success.passwordReset }),
        /* @__PURE__ */ m(Ae, { onClick: h, children: u.resetPasswordPage.success.backToLogin })
      ] }) : /* @__PURE__ */ M($t, { children: [
        /* @__PURE__ */ m(
          Xe,
          {
            onChange: (y) => a(y.target.value),
            type: "password",
            id: "password",
            value: i,
            placeholder: u.common.passwordPlaceholder,
            Icon: () => /* @__PURE__ */ m(ft, {}),
            label: u.common.password,
            isError: !!s
          }
        ),
        /* @__PURE__ */ m("div", { className: "h-5" }),
        /* @__PURE__ */ m(
          Xe,
          {
            onChange: (y) => f(y.target.value),
            type: "password",
            id: "confirm-password",
            value: l,
            placeholder: u.common.passwordPlaceholder,
            Icon: () => /* @__PURE__ */ m(ft, {}),
            label: u.common.confirmPassword,
            isError: !!s
          }
        ),
        /* @__PURE__ */ m("div", { className: "h-2" }),
        /* @__PURE__ */ m(Lt, { error: s }),
        /* @__PURE__ */ M(
          "button",
          {
            onClick: h,
            className: "self-start text-medium hover:underline text-inter text-xs li",
            children: [
              /* @__PURE__ */ m(fs, { className: "transform rotate-90 h-[5px] mb-[2px] inline-block" }),
              u.common.login
            ]
          }
        ),
        /* @__PURE__ */ m("div", { className: "h-16" }),
        /* @__PURE__ */ m(Ae, { showLoading: r.isPending, onClick: c, children: u.resetPasswordPage.resetPassword })
      ] }),
      /* @__PURE__ */ m("div", { className: "h-12" })
    ] }) }),
    /* @__PURE__ */ m(nt, {})
  ] });
}, Ya = ({ email: t, setLocation: e }) => {
  const r = dn(null), [s, n] = W(!1), i = at({ mutationFn: Wa }), a = Fe();
  Ye(() => (l(), () => {
    r.current && window.clearTimeout(r.current);
  }), []);
  const l = () => {
    s || (n(!0), r.current = window.setTimeout(() => {
      n(!1);
    }, 5e3), i.mutate());
  }, f = () => {
    It(), e(null);
  };
  return /* @__PURE__ */ M(Ze, { children: [
    /* @__PURE__ */ m(et, { children: /* @__PURE__ */ M(tt, { children: [
      /* @__PURE__ */ m("div", { className: "h-12" }),
      /* @__PURE__ */ m(rt, {}),
      /* @__PURE__ */ m(st, { text: a.confirmEmailPage.confirmEmailMessage }),
      /* @__PURE__ */ m("p", { className: "self-center bg-black rounded-md px-4 py-1 text-white mx-3 mb-4 text-center tracking-wide", children: t }),
      /* @__PURE__ */ m(
        "button",
        {
          onClick: l,
          disabled: s,
          className: `${i.isPending ? "animate-pulse cursor-default" : s ? "" : "hover:bg-qura-neutral-silver"} border ${s ? "border-qura-neutral-silver/50" : "border-qura-neutral-silver"} disabled:opacity-50 text-xs font-medium bg-qura-neutral-ghost px-2 py-1 self-center rounded-md`,
          children: i.isPending ? a.confirmEmailPage.isLoading : a.confirmEmailPage.resendLink
        }
      ),
      /* @__PURE__ */ m("div", { className: "h-6" }),
      /* @__PURE__ */ m("p", { className: "text-tiny text-center", children: a.confirmEmailPage.spamEmail }),
      /* @__PURE__ */ m("div", { className: "h-20" }),
      /* @__PURE__ */ m(Ae, { onClick: f, children: a.confirmEmailPage.backToLogin }),
      /* @__PURE__ */ m("div", { className: "h-12" })
    ] }) }),
    /* @__PURE__ */ m(nt, {})
  ] });
}, Xa = ({ setLocation: t, verificationToken: e }) => {
  const r = Fe(), s = at({ mutationFn: Va });
  Ye(() => {
    s.mutate(e);
  }, []), Ye(() => {
    s.isSuccess && window.location.reload();
  }, [s.isSuccess]);
  const n = () => {
    It(), t(null);
  };
  return /* @__PURE__ */ M(Ze, { children: [
    /* @__PURE__ */ m(et, { children: /* @__PURE__ */ M(tt, { children: [
      /* @__PURE__ */ m("div", { className: "h-12" }),
      /* @__PURE__ */ m(rt, {}),
      /* @__PURE__ */ m(st, { text: r.confirmEmailPage.confirming }),
      s.isPending && !s.error && /* @__PURE__ */ m("div", { className: "flex justify-center items-center h-10", children: /* @__PURE__ */ m("div", { className: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900" }) }),
      s.error && /* @__PURE__ */ m("div", { className: "h-10", children: /* @__PURE__ */ m("p", { className: "text-center text-sm text-red-500", children: r.confirmEmailPage.confirmingError }) }),
      /* @__PURE__ */ m("div", { className: "h-20" }),
      /* @__PURE__ */ m(Ae, { onClick: n, children: r.confirmEmailPage.backToLogin }),
      /* @__PURE__ */ m("div", { className: "h-12" })
    ] }) }),
    /* @__PURE__ */ m(nt, {})
  ] });
};
function Za() {
  const [t, e] = W(window.location.pathname + window.location.search), r = hn((s) => {
    window.history.pushState({}, "", s), e(s);
  }, []);
  return Ye(() => {
    const s = () => {
      e(window.location.pathname + window.location.search);
    };
    return window.addEventListener("popstate", s), () => {
      window.removeEventListener("popstate", s);
    };
  }, []), [t, r];
}
const eo = yn.literal("forgot-password").nullable();
function to({ children: t, db: e }) {
  const [r, s] = W(""), n = bn(), i = kn(), [a, l] = Za(), [f, u = ""] = a.split("?"), c = new URLSearchParams(u), h = c.get("token"), y = c.get("oobCode"), k = c.get("verification"), w = eo.safeParse(c.get("location")).data ?? null, g = (v) => {
    const E = new URLSearchParams(c);
    v ? E.set("location", v) : E.delete("location"), E.delete("token"), E.delete("verification"), E.delete("oobCode");
    const P = E.toString();
    l(f + (P.length > 0 ? "?" + P : ""));
  }, p = n && n.emailVerified;
  if (Ye(() => {
    p && g(null);
  }, [p]), !i)
    return /* @__PURE__ */ m(gn, {});
  if (p)
    return /* @__PURE__ */ m($t, { children: t });
  if (!n)
    return h ? /* @__PURE__ */ m(
      $a,
      {
        token: h,
        setLocation: g,
        email: r,
        setEmail: s,
        db: e
      }
    ) : y ? /* @__PURE__ */ m(
      Ja,
      {
        setLocation: g,
        oobCode: y
      }
    ) : w === "forgot-password" ? /* @__PURE__ */ m(
      gi,
      {
        email: r,
        setEmail: s,
        setLocation: g
      }
    ) : /* @__PURE__ */ m(
      pi,
      {
        email: r,
        setEmail: s,
        setLocation: g
      }
    );
  if (!n.emailVerified)
    return k ? /* @__PURE__ */ m(
      Xa,
      {
        setLocation: g,
        verificationToken: k
      }
    ) : /* @__PURE__ */ m(
      Ya,
      {
        setLocation: g,
        email: n.email ?? "SOMETHING WENT WRONG, REPORT TO QURA"
      }
    );
}
const ro = new Yn();
function bo({ children: t, db: e, auth: r, disableAuth: s, locale: n }) {
  return /* @__PURE__ */ m(Mn, { locale: n, children: /* @__PURE__ */ M(ri, { client: ro, children: [
    /* @__PURE__ */ m(On, { db: e, auth: r, disableAuth: s }),
    /* @__PURE__ */ m(to, { db: e, children: t })
  ] }) });
}
export {
  bo as AuthWrapper,
  kr as getToken,
  br as login,
  It as logout,
  z as useAuthStore,
  bn as useAuthUser,
  wo as useGetToken,
  kn as useIsAuthInitialized,
  go as useLogin,
  yo as useLogout,
  po as useUserData
};
//# sourceMappingURL=index.js.map
